export const patient = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',
  NavSidebar: {},
  TabInit: { display: 'none', show: (() => { let d = false; return (el, s) => { if (!d) { d = true; Promise.resolve().then(() => { var path = window.location.pathname; var tab = 'overview'; if (path === '/chart') tab = 'chart'; else if (path === '/perio') tab = 'perio'; else if (path === '/treatment-plan') tab = 'treatmentPlan'; else if (path === '/clinical-notes') tab = 'notes'; else if (path === '/medical-history') tab = 'medHistory'; s.root.update({ activeTab: 'patients', activePatientSection: tab, medHistorySubTab: 'conditions', addEventOpen: false, addNewDropOpen: false }) }) } return false } })() },

  MainContent: {
    flow: 'y',
    flex: '1',
    overflow: 'auto',

    TopBar: {},

    ContentArea: {
      flow: 'y',
      gap: 'B',
      padding: 'B',
      flex: '1',
      '@mobileL': { padding: 'A' },

      // ─── PATIENT HEADER ──────────────────────────
      PatientHeader: {
        flow: 'x',
        gap: 'A',
        align: 'center flex-start',
        padding: 'B',
        round: 'A',
        background: 'inkMid',
        border: '1px solid inkBorder',
        '@mobileL': { flow: 'y', align: 'center center', textAlign: 'center' },

        AvatarCircle: {
          width: 'D',
          height: 'D',
          round: 'E',
          background: '#0D1117',
          color: '#FFFFFF',
          fontWeight: '700',
          fontSize: 'B',
          flow: 'x',
          align: 'center center',
          text: 'GB',
          flexShrink: '0'
        },
        PatientInfo: {
          flow: 'y', gap: 'Y', flex: '1',
          PatientName: { tag: 'h2', text: '{{ giorgiBeridze | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'inkText' },
          PatientMeta: {
            flow: 'x', gap: 'A', flexWrap: 'wrap',
            AgeTag: { text: '{{ age34 | polyglot }}', fontSize: 'Z', color: 'inkMuted' },
            PhoneTag: { text: '+995 555 11 22 33', fontSize: 'Z', color: 'inkMuted' },
            LastVisitTag: { text: '{{ lastVisitMar10 | polyglot }}', fontSize: 'Z', color: 'inkMuted' },
            NextApptTag: { text: '{{ nextMar19 | polyglot }}', fontSize: 'Z', color: 'teal' }
          },
          AllergyTags: {
            flow: 'x', gap: 'Y', marginTop: 'Y',
            TagPenicillin: { text: '{{ penicillin | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'red.15', color: 'red' },
            TagLatex: { text: '{{ latex | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'red.15', color: 'red' }
          },
          ChapterTags: {
            flow: 'x', gap: 'Y', marginTop: 'X', flexWrap: 'wrap',
            TagFollowup: { text: 'Follow-up', fontSize: 'Y', fontWeight: '500', padding: 'X Z', round: 'B', background: 'teal.12', color: 'teal' },
            TagRootCanal: { text: 'Root Canal', fontSize: 'Y', fontWeight: '500', padding: 'X Z', round: 'B', background: 'purple.12', color: 'purple' },
            TagRestorative: { text: 'Restorative', fontSize: 'Y', fontWeight: '500', padding: 'X Z', round: 'B', background: 'blue.12', color: 'blue' },
            TagInitial: { text: 'Initial Exam', fontSize: 'Y', fontWeight: '500', padding: 'X Z', round: 'B', background: 'inkSurface', color: 'inkMuted', border: '1px solid inkBorder' }
          }
        }
      },

      // ─── PATIENT TABS (merged with med history subtabs) ──────────────────
      PatientTabs: {
        flow: 'x',
        gap: 'Z',
        borderBottom: '1px solid inkBorder',
        paddingBottom: 'Y',
        flexWrap: 'wrap',
        TabProfile: {
          text: 'Profile',
          fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', whiteSpace: 'nowrap',
          color: (el, s) => s.root.activePatientSection === 'profile' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.activePatientSection === 'profile' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activePatientSection: 'profile' })
        },
        TabOverview: {
          text: 'Timeline',
          fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', whiteSpace: 'nowrap',
          color: (el, s) => s.root.activePatientSection === 'overview' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.activePatientSection === 'overview' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activePatientSection: 'overview' })
        },
        TabChart: {
          text: '{{ navChart | polyglot }}',
          fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', whiteSpace: 'nowrap',
          color: (el, s) => s.root.activePatientSection === 'chart' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.activePatientSection === 'chart' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activePatientSection: 'chart' })
        },
        TabTreatmentPlan: {
          text: '{{ treatmentPlanTab | polyglot }}',
          fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', whiteSpace: 'nowrap',
          color: (el, s) => s.root.activePatientSection === 'treatmentPlan' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.activePatientSection === 'treatmentPlan' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activePatientSection: 'treatmentPlan' })
        },
        TabMedHistory: {
          text: '{{ navMedHistory | polyglot }}',
          fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', whiteSpace: 'nowrap',
          color: (el, s) => s.root.activePatientSection === 'medHistory' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.activePatientSection === 'medHistory' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activePatientSection: 'medHistory' })
        },
        TabDocuments: {
          text: '{{ documents | polyglot }}',
          fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', whiteSpace: 'nowrap',
          color: (el, s) => s.root.activePatientSection === 'documents' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.activePatientSection === 'documents' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activePatientSection: 'documents' })
        },
        TabConsent: {
          text: 'Consent',
          fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', whiteSpace: 'nowrap',
          color: (el, s) => s.root.activePatientSection === 'consent' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.activePatientSection === 'consent' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ activePatientSection: 'consent' })
        },
        MedHistSep: {
          show: (el, s) => s.root.activePatientSection === 'medHistory',
          width: '1px', alignSelf: 'stretch', background: 'inkBorder', margin: '0 Y', flexShrink: '0'
        },
        SubTabConditions: {
          show: (el, s) => s.root.activePatientSection === 'medHistory',
          text: '{{ conditions | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', whiteSpace: 'nowrap',
          color: (el, s) => s.root.medHistorySubTab === 'conditions' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.medHistorySubTab === 'conditions' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ medHistorySubTab: 'conditions' })
        },
        SubTabMedications: {
          show: (el, s) => s.root.activePatientSection === 'medHistory',
          text: '{{ medications | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', whiteSpace: 'nowrap',
          color: (el, s) => s.root.medHistorySubTab === 'medications' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.medHistorySubTab === 'medications' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ medHistorySubTab: 'medications' })
        },
        SubTabAllergies: {
          show: (el, s) => s.root.activePatientSection === 'medHistory',
          text: '{{ allergies | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', whiteSpace: 'nowrap',
          color: (el, s) => s.root.medHistorySubTab === 'allergies' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.medHistorySubTab === 'allergies' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ medHistorySubTab: 'allergies' })
        },
        SubTabVitals: {
          show: (el, s) => s.root.activePatientSection === 'medHistory',
          text: '{{ vitals | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', whiteSpace: 'nowrap',
          color: (el, s) => s.root.medHistorySubTab === 'vitals' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.medHistorySubTab === 'vitals' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ medHistorySubTab: 'vitals' })
        },
        SubTabImaging: {
          show: (el, s) => s.root.activePatientSection === 'medHistory',
          text: '{{ imaging | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', whiteSpace: 'nowrap',
          color: (el, s) => s.root.medHistorySubTab === 'imaging' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.medHistorySubTab === 'imaging' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ medHistorySubTab: 'imaging' })
        },

        // ─── Add New split-button (right side of tab bar) ─
        TabSpacer: { flex: '1' },
        AddNewDropdownWrap: {
          position: 'relative', alignSelf: 'center', flow: 'x',
          // Left: clicking opens the EHR form with current/default type
          AddNewMainBtn: {
            flow: 'x', gap: 'Y', align: 'center center', padding: 'Y A',
            borderRadius: '6px 0 0 6px',
            background: 'teal', color: 'white', fontSize: 'Y', fontWeight: '600', cursor: 'pointer', whiteSpace: 'nowrap',
            onClick: (e, el, s) => s.root.update({ addNewDropOpen: false, addEventOpen: true }),
            BtnLabel: { tag: 'span', text: '+ Add New' }
          },
          // Right: arrow opens the type-picker dropdown
          AddNewArrowBtn: {
            flow: 'x', align: 'center center', padding: 'Y Z',
            borderLeft: '1px solid rgba(255,255,255,0.25)', borderRadius: '0 6px 6px 0',
            background: 'teal', color: 'white', fontSize: 'Y', cursor: 'pointer',
            onClick: (e, el, s) => { e.stopPropagation(); s.root.update({ addNewDropOpen: !s.root.addNewDropOpen }) },
            ArrowIcon: { tag: 'span', text: '▾' }
          },
          DropMenu: {
            show: (el, s) => !!s.root.addNewDropOpen,
            position: 'absolute', top: '110%', right: '0', zIndex: '9999',
            background: 'inkMid', border: '1px solid inkBorder', borderRadius: 'A', overflow: 'hidden',
            minWidth: '240px', boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
            flow: 'y',

            // ── Base Templates ────────────────────
            BaseTemplatesHeader: {
              flow: 'x', align: 'center space-between', padding: 'Y A', borderBottom: '1px solid inkBorder',
              TplHeaderLabel: { text: 'Base Templates', fontSize: 'Y', fontWeight: '700', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: '0.05em' }
            },
            Opt1: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', cursor: 'pointer', color: 'inkText', onClick: (e, el, s) => s.root.update({ addNewDropOpen: false, addEventOpen: true, newEventType: 'Consultation' }), TOpt1Icon: { tag: 'span', text: '📋', fontSize: 'Z' }, TOpt1Info: { flow: 'y', gap: 'X', TOpt1Name: { text: 'Consultation', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, TOpt1Desc: { text: 'SOAP notes, vitals, diagnosis', fontSize: 'X', color: 'inkMuted' } } },
            Opt2: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', cursor: 'pointer', color: 'inkText', onClick: (e, el, s) => s.root.update({ addNewDropOpen: false, addEventOpen: true, newEventType: 'Treatment' }), TOpt2Icon: { tag: 'span', text: '🦷', fontSize: 'Z' }, TOpt2Info: { flow: 'y', gap: 'X', TOpt2Name: { text: 'Treatment', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, TOpt2Desc: { text: 'CDT code, teeth, procedure', fontSize: 'X', color: 'inkMuted' } } },
            Opt3: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', cursor: 'pointer', color: 'inkText', onClick: (e, el, s) => s.root.update({ addNewDropOpen: false, addEventOpen: true, newEventType: 'Diagnosis' }), TOpt3Icon: { tag: 'span', text: '🔬', fontSize: 'Z' }, TOpt3Info: { flow: 'y', gap: 'X', TOpt3Name: { text: 'Diagnosis', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, TOpt3Desc: { text: 'ICD-10, severity, differential', fontSize: 'X', color: 'inkMuted' } } },
            Opt4: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', cursor: 'pointer', color: 'inkText', onClick: (e, el, s) => s.root.update({ addNewDropOpen: false, addEventOpen: true, newEventType: 'Prescription' }), TOpt4Icon: { tag: 'span', text: '💊', fontSize: 'Z' }, TOpt4Info: { flow: 'y', gap: 'X', TOpt4Name: { text: 'Prescription', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, TOpt4Desc: { text: 'Drug, dosage, route, frequency', fontSize: 'X', color: 'inkMuted' } } },
            Opt5: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', cursor: 'pointer', color: 'inkText', onClick: (e, el, s) => s.root.update({ addNewDropOpen: false, addEventOpen: true, newEventType: 'Imaging / Radiology' }), TOpt5Icon: { tag: 'span', text: '🩻', fontSize: 'Z' }, TOpt5Info: { flow: 'y', gap: 'X', TOpt5Name: { text: 'Imaging / X-ray', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, TOpt5Desc: { text: 'DICOM, upload, radiation dose', fontSize: 'X', color: 'inkMuted' } } },
            Opt6: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', cursor: 'pointer', color: 'inkText', onClick: (e, el, s) => s.root.update({ addNewDropOpen: false, addEventOpen: true, newEventType: 'Lab Result' }), TOpt6Icon: { tag: 'span', text: '🧪', fontSize: 'Z' }, TOpt6Info: { flow: 'y', gap: 'X', TOpt6Name: { text: 'Lab Result', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, TOpt6Desc: { text: 'LOINC, values, reference ranges', fontSize: 'X', color: 'inkMuted' } } },
            Opt7: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', cursor: 'pointer', color: 'inkText', onClick: (e, el, s) => s.root.update({ addNewDropOpen: false, addEventOpen: true, newEventType: 'Referral' }), TOpt7Icon: { tag: 'span', text: '📤', fontSize: 'Z' }, TOpt7Info: { flow: 'y', gap: 'X', TOpt7Name: { text: 'Referral', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, TOpt7Desc: { text: 'Specialist, reason, urgency', fontSize: 'X', color: 'inkMuted' } } },
            Opt8: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', cursor: 'pointer', color: 'inkText', onClick: (e, el, s) => s.root.update({ addNewDropOpen: false, addEventOpen: true, newEventType: 'Surgery' }), TOpt8Icon: { tag: 'span', text: '🔪', fontSize: 'Z' }, TOpt8Info: { flow: 'y', gap: 'X', TOpt8Name: { text: 'Surgery', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, TOpt8Desc: { text: 'CDT/CPT, anesthesia, team', fontSize: 'X', color: 'inkMuted' } } },
            Opt9: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', cursor: 'pointer', color: 'inkText', onClick: (e, el, s) => s.root.update({ addNewDropOpen: false, addEventOpen: true, newEventType: 'Note' }), TOpt9Icon: { tag: 'span', text: '📝', fontSize: 'Z' }, TOpt9Info: { flow: 'y', gap: 'X', TOpt9Name: { text: 'Note', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, TOpt9Desc: { text: 'Free-text clinical note', fontSize: 'X', color: 'inkMuted' } } },
            Opt10: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', cursor: 'pointer', color: 'inkText', onClick: (e, el, s) => s.root.update({ addNewDropOpen: false, addEventOpen: true, newEventType: 'Follow-up' }), TOpt10Icon: { tag: 'span', text: '↩', fontSize: 'Z' }, TOpt10Info: { flow: 'y', gap: 'X', TOpt10Name: { text: 'Follow-up', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, TOpt10Desc: { text: 'Post-treatment check, SOAP', fontSize: 'X', color: 'inkMuted' } } },

            // ── Custom Templates ─────────────────
            CustomSep: { height: '1px', background: 'inkBorder' },
            CustomHeader: {
              flow: 'x', align: 'center space-between', padding: 'Y A',
              CustHeaderLabel: { text: 'Custom Templates', fontSize: 'Y', fontWeight: '700', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: '0.05em' }
            },
            CustomTpl1: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', cursor: 'pointer', onClick: (e, el, s) => s.root.update({ addNewDropOpen: false, addEventOpen: true, newEventType: 'Consultation' }), CTpl1Icon: { tag: 'span', text: '⭐', fontSize: 'Z' }, CTpl1Info: { flow: 'y', gap: 'X', CTpl1Name: { text: 'New Patient Intake', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, CTpl1Desc: { text: 'Based on Consultation', fontSize: 'X', color: 'inkMuted' } } },
            CustomTpl2: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', cursor: 'pointer', onClick: (e, el, s) => s.root.update({ addNewDropOpen: false, addEventOpen: true, newEventType: 'Treatment' }), CTpl2Icon: { tag: 'span', text: '⭐', fontSize: 'Z' }, CTpl2Info: { flow: 'y', gap: 'X', CTpl2Name: { text: 'Root Canal Protocol', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, CTpl2Desc: { text: 'Based on Treatment', fontSize: 'X', color: 'inkMuted' } } },
            AddCustomBtn: {
              flow: 'x', gap: 'Y', align: 'center center',
              padding: 'Z A', cursor: 'pointer', borderTop: '1px solid inkBorder',
              background: 'ink',
              AddCustIcon: { tag: 'span', text: '+', fontSize: 'A', color: 'teal', fontWeight: '700' },
              AddCustLabel: { text: 'Create Custom Template', fontSize: 'Z', fontWeight: '600', color: 'teal' }
            }
          }
        }
      },

      // ═══════════════════════════════════════════════
      // 0. PROFILE
      // ═══════════════════════════════════════════════
      ProfileSection: {
        flow: 'y', gap: 'A',
        show: (el, s) => s.root.activePatientSection === 'profile',

        ProfileGrid: {
          flow: 'x', gap: 'A', flexWrap: 'wrap', align: 'flex-start flex-start',

          // ─── Left Column ──────────────────────────
          ProfileLeft: {
            flow: 'y', gap: 'A', flex: '1', minWidth: '260px',

            PersonalCard: {
              flow: 'y', gap: 'Z', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
              CardTitle: { tag: 'h4', text: 'Personal Information', fontSize: 'Z', fontWeight: '700', color: 'inkText', marginBottom: 'X' },
              PRow1: { flow: 'x', gap: 'A', flexWrap: 'wrap',
                DOBField: { flow: 'y', gap: 'X', flex: '1', DOBLabel: { text: 'Date of Birth', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, DOBVal: { text: 'Mar 14, 1992', fontSize: 'Z', color: 'inkText' } },
                GenderField: { flow: 'y', gap: 'X', flex: '1', GLabel: { text: 'Gender', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, GVal: { text: 'Male', fontSize: 'Z', color: 'inkText' } },
                BloodField: { flow: 'y', gap: 'X', flex: '1', BLabel: { text: 'Blood Type', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, BVal: { text: 'A+', fontSize: 'Z', color: 'red', fontWeight: '600' } }
              },
              PRow2: { flow: 'x', gap: 'A', flexWrap: 'wrap',
                EmailField: { flow: 'y', gap: 'X', flex: '1', ELabel: { text: 'Email', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, EVal: { text: 'giorgi.beridze@gmail.com', fontSize: 'Z', color: 'teal' } },
                PhoneField: { flow: 'y', gap: 'X', flex: '1', PLabel: { text: 'Phone', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, PVal: { text: '+995 555 11 22 33', fontSize: 'Z', color: 'inkText' } }
              },
              PRow3: { flow: 'x', gap: 'A', flexWrap: 'wrap',
                AddressField: { flow: 'y', gap: 'X', flex: '2', ALabel: { text: 'Address', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, AVal: { text: '14 Rustaveli Ave, Tbilisi, Georgia', fontSize: 'Z', color: 'inkText' } },
                LangField: { flow: 'y', gap: 'X', flex: '1', LLabel: { text: 'Language', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, LVal: { text: 'Georgian / English', fontSize: 'Z', color: 'inkText' } }
              }
            },

            EmergencyCard: {
              flow: 'y', gap: 'Z', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
              ECTitle: { tag: 'h4', text: 'Emergency Contact', fontSize: 'Z', fontWeight: '700', color: 'inkText', marginBottom: 'X' },
              ECRow: { flow: 'x', gap: 'A', flexWrap: 'wrap',
                ECName: { flow: 'y', gap: 'X', flex: '1', ECNLabel: { text: 'Name', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, ECNVal: { text: 'Nino Beridze', fontSize: 'Z', color: 'inkText' } },
                ECRel: { flow: 'y', gap: 'X', flex: '1', ECRLabel: { text: 'Relationship', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, ECRVal: { text: 'Spouse', fontSize: 'Z', color: 'inkText' } },
                ECPhone: { flow: 'y', gap: 'X', flex: '1', ECPLabel: { text: 'Phone', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, ECPVal: { text: '+995 555 44 55 66', fontSize: 'Z', color: 'inkText' } }
              }
            },

            RefSourceCard: {
              flow: 'y', gap: 'Z', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
              RefTitle: { tag: 'h4', text: 'Referral & Source', fontSize: 'Z', fontWeight: '700', color: 'inkText', marginBottom: 'X' },
              RefRow: { flow: 'x', gap: 'A', flexWrap: 'wrap',
                RefSource: { flow: 'y', gap: 'X', flex: '1', RSLabel: { text: 'How they found us', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, RSVal: { text: 'Referred by Dr. Lomidze', fontSize: 'Z', color: 'inkText' } },
                RefDate: { flow: 'y', gap: 'X', flex: '1', RDLabel: { text: 'First Visit', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, RDVal: { text: 'Jan 10, 2026', fontSize: 'Z', color: 'inkText' } },
                RefStatus: { flow: 'y', gap: 'X', flex: '1', RStLabel: { text: 'Patient Status', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, RStVal: { text: 'Active', fontSize: 'Z', color: 'green', fontWeight: '600' } }
              }
            }
          },

          // ─── Right Column ─────────────────────────
          ProfileRight: {
            flow: 'y', gap: 'A', flex: '1', minWidth: '260px',

            InsuranceCard: {
              flow: 'y', gap: 'Z', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
              InsTitle: { tag: 'h4', text: 'Insurance', fontSize: 'Z', fontWeight: '700', color: 'inkText', marginBottom: 'X' },
              InsRow1: { flow: 'x', gap: 'A', flexWrap: 'wrap',
                InsProv: { flow: 'y', gap: 'X', flex: '1', IPLabel: { text: 'Provider', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, IPVal: { text: 'GPI Insurance', fontSize: 'Z', color: 'inkText' } },
                InsPlan: { flow: 'y', gap: 'X', flex: '1', IPlanLabel: { text: 'Plan', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, IPlanVal: { text: 'Gold Dental Plus', fontSize: 'Z', color: 'inkText' } }
              },
              InsRow2: { flow: 'x', gap: 'A', flexWrap: 'wrap',
                InsMemberId: { flow: 'y', gap: 'X', flex: '1', IMLabel: { text: 'Member ID', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, IMVal: { text: 'GPI-2026-48291', fontSize: 'Z', color: 'teal', fontWeight: '600' } },
                InsGroup: { flow: 'y', gap: 'X', flex: '1', IGLabel: { text: 'Group', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, IGVal: { text: 'GRP-9041', fontSize: 'Z', color: 'inkText' } },
                InsExp: { flow: 'y', gap: 'X', flex: '1', IELabel: { text: 'Expiry', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, IEVal: { text: 'Dec 31, 2026', fontSize: 'Z', color: 'inkText' } }
              },
              InsCoverageRow: { flow: 'x', gap: 'A', flexWrap: 'wrap', marginTop: 'Y',
                CovPreventive: { flow: 'y', gap: 'X', flex: '1', CPLabel: { text: 'Preventive', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, CPVal: { text: '100%', fontSize: 'Z', color: 'green', fontWeight: '700' } },
                CovBasic: { flow: 'y', gap: 'X', flex: '1', CBLabel: { text: 'Basic', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, CBVal: { text: '80%', fontSize: 'Z', color: 'teal', fontWeight: '700' } },
                CovMajor: { flow: 'y', gap: 'X', flex: '1', CMLabel: { text: 'Major', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, CMVal: { text: '50%', fontSize: 'Z', color: 'gold', fontWeight: '700' } },
                CovOrtho: { flow: 'y', gap: 'X', flex: '1', COLabel: { text: 'Ortho', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, COVal: { text: 'Not covered', fontSize: 'Z', color: 'inkMuted' } }
              }
            },

            PrimaryDoctorCard: {
              flow: 'y', gap: 'Z', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
              PDTitle: { tag: 'h4', text: 'Care Team', fontSize: 'Z', fontWeight: '700', color: 'inkText', marginBottom: 'X' },
              DoctorRow1: { flow: 'x', gap: 'Z', align: 'center flex-start',
                DAvatar1: { width: 'C', height: 'C', round: 'E', background: 'teal.20', color: 'teal', fontWeight: '700', fontSize: 'Y', flow: 'x', align: 'center center', text: 'LK', flexShrink: '0' },
                DInfo1: { flow: 'y', gap: 'X', flex: '1', DName1: { text: 'Dr. Luka Kvaratskhelia', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, DRole1: { text: 'Primary Dentist · General & Restorative', fontSize: 'Y', color: 'inkMuted' } }
              },
              DoctorRow2: { flow: 'x', gap: 'Z', align: 'center flex-start',
                DAvatar2: { width: 'C', height: 'C', round: 'E', background: 'purple.20', color: 'purple', fontWeight: '700', fontSize: 'Y', flow: 'x', align: 'center center', text: 'NB', flexShrink: '0' },
                DInfo2: { flow: 'y', gap: 'X', flex: '1', DName2: { text: 'Dr. Nata Beridze', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, DRole2: { text: 'Periodontist', fontSize: 'Y', color: 'inkMuted' } }
              }
            },

            AllergiesCard: {
              flow: 'y', gap: 'Z', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid red.20',
              AlgTitle: { tag: 'h4', text: '⚠ Allergies & Alerts', fontSize: 'Z', fontWeight: '700', color: 'red', marginBottom: 'X' },
              AlgRow: { flow: 'x', gap: 'Z', flexWrap: 'wrap',
                AlgPenicillin: { flow: 'y', gap: 'X', padding: 'Y Z', round: 'Y', background: 'red.08', border: '1px solid red.20',
                  AlgName: { text: 'Penicillin', fontSize: 'Z', fontWeight: '700', color: 'red' },
                  AlgSeverity: { text: 'Severe · Anaphylaxis', fontSize: 'Y', color: 'inkMuted' }
                },
                AlgLatex: { flow: 'y', gap: 'X', padding: 'Y Z', round: 'Y', background: 'red.08', border: '1px solid red.20',
                  AlgName2: { text: 'Latex', fontSize: 'Z', fontWeight: '700', color: 'red' },
                  AlgSeverity2: { text: 'Moderate · Contact dermatitis', fontSize: 'Y', color: 'inkMuted' }
                }
              },
              AlgNote: { text: 'Always verify before prescribing antibiotics. Latex-free gloves required.', fontSize: 'Y', color: 'inkMuted', marginTop: 'Y', fontStyle: 'italic' }
            },

            PreferencesCard: {
              flow: 'y', gap: 'Z', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
              PrefTitle: { tag: 'h4', text: 'Preferences & Notes', fontSize: 'Z', fontWeight: '700', color: 'inkText', marginBottom: 'X' },
              PrefRows: { flow: 'y', gap: 'Z',
                PrefAnx: { flow: 'x', gap: 'Z', align: 'center flex-start', PrefIcon: { text: '😰', fontSize: 'Z' }, PrefText: { flow: 'y', gap: 'X', PrefLabel: { text: 'Dental anxiety', fontSize: 'Y', fontWeight: '600', color: 'inkText' }, PrefDesc: { text: 'Moderate — prefers detailed explanations before procedures', fontSize: 'Y', color: 'inkMuted' } } },
                PrefLang: { flow: 'x', gap: 'Z', align: 'center flex-start', PrefIcon2: { text: '🌐', fontSize: 'Z' }, PrefText2: { flow: 'y', gap: 'X', PrefLabel2: { text: 'Preferred language', fontSize: 'Y', fontWeight: '600', color: 'inkText' }, PrefDesc2: { text: 'Georgian primary, English accepted', fontSize: 'Y', color: 'inkMuted' } } },
                PrefAppt: { flow: 'x', gap: 'Z', align: 'center flex-start', PrefIcon3: { text: '🕐', fontSize: 'Z' }, PrefText3: { flow: 'y', gap: 'X', PrefLabel3: { text: 'Appointment preference', fontSize: 'Y', fontWeight: '600', color: 'inkText' }, PrefDesc3: { text: 'Morning appointments, weekdays only', fontSize: 'Y', color: 'inkMuted' } } },
                PrefComm: { flow: 'x', gap: 'Z', align: 'center flex-start', PrefIcon4: { text: '📱', fontSize: 'Z' }, PrefText4: { flow: 'y', gap: 'X', PrefLabel4: { text: 'Communication', fontSize: 'Y', fontWeight: '600', color: 'inkText' }, PrefDesc4: { text: 'SMS reminders preferred, no cold calls', fontSize: 'Y', color: 'inkMuted' } } }
              }
            }
          }
        }
      },

      // ═══════════════════════════════════════════════
      // 1. OVERVIEW
      // ═══════════════════════════════════════════════
      OverviewSection: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.activePatientSection === 'overview',

        // ─── Add Event Form Panel (EHR-ready) ─────
        AddEventPanel: {
          show: (el, s) => s.root.addEventOpen,
          flow: 'y', gap: 'Z', padding: 'A', round: 'A',
          background: 'inkMid', border: '1px solid teal', marginBottom: 'A',

          PanelHeader: {
            flow: 'x', align: 'center space-between', marginBottom: 'Z',
            PanelLeft: {
              flow: 'y', gap: 'X',
              PanelTitle: { tag: 'h4', text: 'New Record', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
              PanelSubtitle: { text: 'All fields marked * are required for EHR sync', fontSize: 'X', color: 'inkMuted' }
            },
            CloseBtn: { tag: 'span', text: '✕', fontSize: 'Z', color: 'inkMuted', cursor: 'pointer', padding: 'Y', onClick: (e, el, s) => s.root.update({ addEventOpen: false }) }
          },

          // ── Record Type Selector (top of form) ─
          RecordTypeRow: {
            flow: 'x', gap: 'Y', flexWrap: 'wrap', marginBottom: 'Z',
            padding: 'Z A', background: 'ink', round: 'Y', border: '1px solid inkBorder',
            TypeRowLabel: { tag: 'span', text: 'Record Type:', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', alignSelf: 'center', whiteSpace: 'nowrap', marginRight: 'Y' },
            TypeChip1: { tag: 'span', text: '📋 Consultation', fontSize: 'Y', padding: 'X Z', borderRadius: '20px', cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: (el, s) => (s.root.newEventType || 'Consultation') === 'Consultation' ? '700' : '400', background: (el, s) => (s.root.newEventType || 'Consultation') === 'Consultation' ? 'teal' : 'inkMid', color: (el, s) => (s.root.newEventType || 'Consultation') === 'Consultation' ? 'white' : 'inkText', onClick: (e, el, s) => s.root.update({ newEventType: 'Consultation' }) },
            TypeChip2: { tag: 'span', text: '🦷 Treatment', fontSize: 'Y', padding: 'X Z', borderRadius: '20px', cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: (el, s) => s.root.newEventType === 'Treatment' ? '700' : '400', background: (el, s) => s.root.newEventType === 'Treatment' ? 'teal' : 'inkMid', color: (el, s) => s.root.newEventType === 'Treatment' ? 'white' : 'inkText', onClick: (e, el, s) => s.root.update({ newEventType: 'Treatment' }) },
            TypeChip3: { tag: 'span', text: '🔬 Diagnosis', fontSize: 'Y', padding: 'X Z', borderRadius: '20px', cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: (el, s) => s.root.newEventType === 'Diagnosis' ? '700' : '400', background: (el, s) => s.root.newEventType === 'Diagnosis' ? 'teal' : 'inkMid', color: (el, s) => s.root.newEventType === 'Diagnosis' ? 'white' : 'inkText', onClick: (e, el, s) => s.root.update({ newEventType: 'Diagnosis' }) },
            TypeChip4: { tag: 'span', text: '💊 Prescription', fontSize: 'Y', padding: 'X Z', borderRadius: '20px', cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: (el, s) => s.root.newEventType === 'Prescription' ? '700' : '400', background: (el, s) => s.root.newEventType === 'Prescription' ? 'teal' : 'inkMid', color: (el, s) => s.root.newEventType === 'Prescription' ? 'white' : 'inkText', onClick: (e, el, s) => s.root.update({ newEventType: 'Prescription' }) },
            TypeChip5: { tag: 'span', text: '🩻 Imaging', fontSize: 'Y', padding: 'X Z', borderRadius: '20px', cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: (el, s) => s.root.newEventType === 'Imaging / Radiology' ? '700' : '400', background: (el, s) => s.root.newEventType === 'Imaging / Radiology' ? 'teal' : 'inkMid', color: (el, s) => s.root.newEventType === 'Imaging / Radiology' ? 'white' : 'inkText', onClick: (e, el, s) => s.root.update({ newEventType: 'Imaging / Radiology' }) },
            TypeChip6: { tag: 'span', text: '🧪 Lab Result', fontSize: 'Y', padding: 'X Z', borderRadius: '20px', cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: (el, s) => s.root.newEventType === 'Lab Result' ? '700' : '400', background: (el, s) => s.root.newEventType === 'Lab Result' ? 'teal' : 'inkMid', color: (el, s) => s.root.newEventType === 'Lab Result' ? 'white' : 'inkText', onClick: (e, el, s) => s.root.update({ newEventType: 'Lab Result' }) },
            TypeChip7: { tag: 'span', text: '📤 Referral', fontSize: 'Y', padding: 'X Z', borderRadius: '20px', cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: (el, s) => s.root.newEventType === 'Referral' ? '700' : '400', background: (el, s) => s.root.newEventType === 'Referral' ? 'teal' : 'inkMid', color: (el, s) => s.root.newEventType === 'Referral' ? 'white' : 'inkText', onClick: (e, el, s) => s.root.update({ newEventType: 'Referral' }) },
            TypeChip8: { tag: 'span', text: '🔪 Surgery', fontSize: 'Y', padding: 'X Z', borderRadius: '20px', cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: (el, s) => s.root.newEventType === 'Surgery' ? '700' : '400', background: (el, s) => s.root.newEventType === 'Surgery' ? 'teal' : 'inkMid', color: (el, s) => s.root.newEventType === 'Surgery' ? 'white' : 'inkText', onClick: (e, el, s) => s.root.update({ newEventType: 'Surgery' }) },
            TypeChip9: { tag: 'span', text: '📝 Note', fontSize: 'Y', padding: 'X Z', borderRadius: '20px', cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: (el, s) => s.root.newEventType === 'Note' ? '700' : '400', background: (el, s) => s.root.newEventType === 'Note' ? 'teal' : 'inkMid', color: (el, s) => s.root.newEventType === 'Note' ? 'white' : 'inkText', onClick: (e, el, s) => s.root.update({ newEventType: 'Note' }) },
            TypeChip10: { tag: 'span', text: '↩ Follow-up', fontSize: 'Y', padding: 'X Z', borderRadius: '20px', cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: (el, s) => s.root.newEventType === 'Follow-up' ? '700' : '400', background: (el, s) => s.root.newEventType === 'Follow-up' ? 'teal' : 'inkMid', color: (el, s) => s.root.newEventType === 'Follow-up' ? 'white' : 'inkText', onClick: (e, el, s) => s.root.update({ newEventType: 'Follow-up' }) }
          },

          // ── EHR Sync Block ──────────────────────
          EhrSyncBlock: {
            flow: 'y', gap: 'Z', padding: 'Z A', round: 'Y', background: 'ink', border: '1px solid inkBorder',
            EhrBlockTitle: { text: 'EHR / System Sync', fontSize: 'Y', fontWeight: '700', color: 'teal', marginBottom: 'X' },
            EhrRow1: {
              flow: 'x', gap: 'A', flexWrap: 'wrap',
              EhrSystemField: {
                flow: 'y', gap: 'X', flex: '1', minWidth: '160px',
                EhrSysLabel: { tag: 'label', text: 'EHR System', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
                EhrSysSelect: {
                  tag: 'select', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid',
                  border: '1px solid inkBorder', color: 'inkText', width: '100%',
                  children: [
                    { tag: 'option', text: '— None —' },
                    { tag: 'option', text: 'Epic' },
                    { tag: 'option', text: 'Cerner / Oracle Health' },
                    { tag: 'option', text: 'OpenDental' },
                    { tag: 'option', text: 'Dentrix' },
                    { tag: 'option', text: 'Curve Dental' },
                    { tag: 'option', text: 'Carestream Dental' },
                    { tag: 'option', text: 'Eaglesoft' },
                    { tag: 'option', text: 'FHIR R4 Endpoint' },
                    { tag: 'option', text: 'HL7 v2' }
                  ]
                }
              },
              EhrIdField: {
                flow: 'y', gap: 'X', flex: '1', minWidth: '140px',
                EhrIdLabel: { tag: 'label', text: 'External Record ID', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
                EhrIdInput: { tag: 'input', type: 'text', placeholder: 'e.g. EHR-2026-00847', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
              },
              SyncStatusField: {
                flow: 'y', gap: 'X', flex: '1', minWidth: '120px',
                SyncLabel: { tag: 'label', text: 'Sync Status', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
                SyncSelect: {
                  tag: 'select', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid',
                  border: '1px solid inkBorder', color: 'inkText', width: '100%',
                  children: [
                    { tag: 'option', text: 'Not Synced' },
                    { tag: 'option', text: 'Sync on Save' },
                    { tag: 'option', text: 'Manual Sync' }
                  ]
                }
              }
            },
            EhrRow2: {
              flow: 'x', gap: 'A', flexWrap: 'wrap',
              IcdField: {
                flow: 'y', gap: 'X', flex: '1', minWidth: '140px',
                IcdLabel: { tag: 'label', text: 'ICD-10 Diagnosis Code', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
                IcdInput: { tag: 'input', type: 'text', placeholder: 'e.g. K04.0', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
              },
              CdtField: {
                flow: 'y', gap: 'X', flex: '1', minWidth: '140px',
                CdtLabel: { tag: 'label', text: 'CDT / CPT Procedure Code *', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
                CdtInput: { tag: 'input', type: 'text', placeholder: 'e.g. D3310', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
              },
              SnomedField: {
                flow: 'y', gap: 'X', flex: '1', minWidth: '140px',
                SnomedLabel: { tag: 'label', text: 'SNOMED CT Code', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
                SnomedInput: { tag: 'input', type: 'text', placeholder: 'e.g. 109355002', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
              },
              LoincField: {
                flow: 'y', gap: 'X', flex: '1', minWidth: '140px',
                LoincLabel: { tag: 'label', text: 'LOINC (Labs/Vitals)', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
                LoincInput: { tag: 'input', type: 'text', placeholder: 'e.g. 2160-0', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
              }
            }
          },

          // ── Core Fields ─────────────────────────
          CoreRow1: {
            flow: 'x', gap: 'A', flexWrap: 'wrap',
            EventTypeField: {
              flow: 'y', gap: 'X', flex: '1', minWidth: '160px',
              TypeLabel: { tag: 'label', text: 'Event Type *', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
              TypeSelect: {
                tag: 'select', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'ink',
                border: '1px solid inkBorder', color: 'inkText', width: '100%',
                children: [
                  { tag: 'option', text: 'Consultation' },
                  { tag: 'option', text: 'Treatment' },
                  { tag: 'option', text: 'Diagnosis' },
                  { tag: 'option', text: 'Prescription' },
                  { tag: 'option', text: 'Imaging / Radiology' },
                  { tag: 'option', text: 'Lab Result' },
                  { tag: 'option', text: 'Referral' },
                  { tag: 'option', text: 'Surgery' },
                  { tag: 'option', text: 'Follow-up' },
                  { tag: 'option', text: 'Note' },
                  { tag: 'option', text: 'Other' }
                ]
              }
            },
            DateField: {
              flow: 'y', gap: 'X', flex: '1', minWidth: '140px',
              DateLabel: { tag: 'label', text: 'Date *', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
              DateInput: { tag: 'input', type: 'date', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
            },
            TimeField: {
              flow: 'y', gap: 'X', flex: '1', minWidth: '110px',
              TimeLabel: { tag: 'label', text: 'Time', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
              TimeInput: { tag: 'input', type: 'time', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
            },
            DurationField: {
              flow: 'y', gap: 'X', flex: '1', minWidth: '100px',
              DurLabel: { tag: 'label', text: 'Duration', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
              DurInput: { tag: 'input', type: 'text', placeholder: 'e.g. 30 min', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
            }
          },

          CoreRow2: {
            flow: 'x', gap: 'A', flexWrap: 'wrap',
            DoctorField: {
              flow: 'y', gap: 'X', flex: '1', minWidth: '180px',
              DocLabel: { tag: 'label', text: 'Doctor / Personnel *', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
              DocSelect: {
                tag: 'select', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'ink',
                border: '1px solid inkBorder', color: 'inkText', width: '100%',
                children: [
                  { tag: 'option', text: 'Dr. Ana Lomidze' },
                  { tag: 'option', text: 'Dr. Giorgi Kvaratskhelia' },
                  { tag: 'option', text: 'Dr. Nino Beridze' },
                  { tag: 'option', text: 'Nurse Salome' },
                  { tag: 'option', text: 'Hygienist Tamar' }
                ]
              }
            },
            CabinetField: {
              flow: 'y', gap: 'X', flex: '1', minWidth: '120px',
              CabLabel: { tag: 'label', text: 'Cabinet', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
              CabSelect: {
                tag: 'select', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'ink',
                border: '1px solid inkBorder', color: 'inkText', width: '100%',
                children: [
                  { tag: 'option', text: 'Cabinet 1' },
                  { tag: 'option', text: 'Cabinet 2' },
                  { tag: 'option', text: 'Cabinet 3' },
                  { tag: 'option', text: 'Cabinet 4' }
                ]
              }
            },
            TeethField: {
              flow: 'y', gap: 'X', flex: '1', minWidth: '140px',
              TeethLabel: { tag: 'label', text: 'Teeth Involved', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
              TeethInput: { tag: 'input', type: 'text', placeholder: 'e.g. #14, #21', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
            }
          },

          TitleField: {
            flow: 'y', gap: 'X',
            TitleLabel: { tag: 'label', text: 'Title *', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
            TitleInput: { tag: 'input', type: 'text', placeholder: 'Event title…', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
          },

          // ── SOAP Notes ──────────────────────────
          SoapBlock: {
            show: (el, s) => { var t = s.root.newEventType || 'Consultation'; return ['Consultation', 'Follow-up', 'Treatment', 'Surgery', 'Diagnosis'].indexOf(t) !== -1 },
            flow: 'y', gap: 'Z', padding: 'Z A', round: 'Y', background: 'ink', border: '1px solid inkBorder',
            SoapTitle: { text: 'SOAP Notes', fontSize: 'Y', fontWeight: '700', color: 'inkText', marginBottom: 'X' },
            SubjectiveField: {
              flow: 'y', gap: 'X',
              SLabel: { tag: 'label', text: 'S — Subjective (Chief Complaint)', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
              SInput: { tag: 'textarea', placeholder: 'Patient-reported symptoms, history of present illness…', fontSize: 'Z', padding: 'Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%', minHeight: 'E', resize: 'vertical', lineHeight: '1.6' }
            },
            ObjectiveField: {
              flow: 'y', gap: 'X',
              OLabel: { tag: 'label', text: 'O — Objective (Clinical Findings)', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
              OInput: { tag: 'textarea', placeholder: 'Examination findings, vitals, test results…', fontSize: 'Z', padding: 'Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%', minHeight: 'E', resize: 'vertical', lineHeight: '1.6' }
            },
            AssessmentField: {
              flow: 'y', gap: 'X',
              ALabel: { tag: 'label', text: 'A — Assessment (Diagnosis)', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
              AInput: { tag: 'textarea', placeholder: 'Clinical diagnosis, differential diagnosis…', fontSize: 'Z', padding: 'Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%', minHeight: 'E', resize: 'vertical', lineHeight: '1.6' }
            },
            PlanField: {
              flow: 'y', gap: 'X',
              PLabel: { tag: 'label', text: 'P — Plan (Treatment)', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
              PInput: { tag: 'textarea', placeholder: 'Treatment plan, medications, follow-up instructions…', fontSize: 'Z', padding: 'Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%', minHeight: 'E', resize: 'vertical', lineHeight: '1.6' }
            }
          },

          // ── Vitals ─────────────────────────────
          VitalsBlock: {
            show: (el, s) => { var t = s.root.newEventType || 'Consultation'; return ['Consultation', 'Follow-up', 'Surgery'].indexOf(t) !== -1 },
            flow: 'y', gap: 'Z', padding: 'Z A', round: 'Y', background: 'ink', border: '1px solid inkBorder',
            VitalsTitle: { text: 'Vital Signs', fontSize: 'Y', fontWeight: '700', color: 'inkText', marginBottom: 'X' },
            VitalsRow: {
              flow: 'x', gap: 'A', flexWrap: 'wrap',
              BpField: {
                flow: 'y', gap: 'X', flex: '1', minWidth: '100px',
                BpLabel: { tag: 'label', text: 'BP (mmHg)', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
                BpInput: { tag: 'input', type: 'text', placeholder: '120/80', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
              },
              HrField: {
                flow: 'y', gap: 'X', flex: '1', minWidth: '90px',
                HrLabel: { tag: 'label', text: 'HR (bpm)', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
                HrInput: { tag: 'input', type: 'text', placeholder: '72', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
              },
              TempField: {
                flow: 'y', gap: 'X', flex: '1', minWidth: '90px',
                TempLabel: { tag: 'label', text: 'Temp (°C)', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
                TempInput: { tag: 'input', type: 'text', placeholder: '36.6', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
              },
              O2Field: {
                flow: 'y', gap: 'X', flex: '1', minWidth: '90px',
                O2Label: { tag: 'label', text: 'SpO₂ (%)', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
                O2Input: { tag: 'input', type: 'text', placeholder: '98', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
              },
              WeightField: {
                flow: 'y', gap: 'X', flex: '1', minWidth: '90px',
                WeightLabel: { tag: 'label', text: 'Weight (kg)', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
                WeightInput: { tag: 'input', type: 'text', placeholder: '70', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
              }
            }
          },

          // ── Medication / Prescription ──────────
          MedBlock: {
            show: (el, s) => (s.root.newEventType || 'Consultation') === 'Prescription',
            flow: 'y', gap: 'Z', padding: 'Z A', round: 'Y', background: 'ink', border: '1px solid inkBorder',
            MedTitle: { text: 'Medication / Prescription', fontSize: 'Y', fontWeight: '700', color: 'inkText', marginBottom: 'X' },
            MedRow1: {
              flow: 'x', gap: 'A', flexWrap: 'wrap',
              DrugField: {
                flow: 'y', gap: 'X', flex: '2', minWidth: '160px',
                DrugLabel: { tag: 'label', text: 'Drug Name', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
                DrugInput: { tag: 'input', type: 'text', placeholder: 'e.g. Amoxicillin', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
              },
              DoseField: {
                flow: 'y', gap: 'X', flex: '1', minWidth: '100px',
                DoseLabel: { tag: 'label', text: 'Dosage', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
                DoseInput: { tag: 'input', type: 'text', placeholder: '500mg', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
              },
              FreqField: {
                flow: 'y', gap: 'X', flex: '1', minWidth: '110px',
                FreqLabel: { tag: 'label', text: 'Frequency', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
                FreqInput: { tag: 'input', type: 'text', placeholder: 'TID x 7 days', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' }
              },
              RouteField: {
                flow: 'y', gap: 'X', flex: '1', minWidth: '100px',
                RouteLabel: { tag: 'label', text: 'Route', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
                RouteSelect: {
                  tag: 'select', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid',
                  border: '1px solid inkBorder', color: 'inkText', width: '100%',
                  children: [
                    { tag: 'option', text: 'Oral' },
                    { tag: 'option', text: 'Topical' },
                    { tag: 'option', text: 'IV' },
                    { tag: 'option', text: 'IM' },
                    { tag: 'option', text: 'Sublingual' },
                    { tag: 'option', text: 'Inhalation' }
                  ]
                }
              }
            }
          },

          // ── Attachments ─────────────────────────
          AttachmentsRow: {
            show: (el, s) => { var t = s.root.newEventType || 'Consultation'; return ['Imaging / Radiology', 'Lab Result', 'Treatment', 'Surgery', 'Referral'].indexOf(t) !== -1 },
            flow: 'x', gap: 'A', flexWrap: 'wrap',
            ImagesField: {
              flow: 'y', gap: 'X', flex: '1', minWidth: '200px',
              ImgLabel: { tag: 'label', text: 'Attach Images / X-rays / DICOM', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
              ImgUploadBox: {
                flow: 'y', align: 'center center', gap: 'Y', padding: 'B A',
                round: 'Y', border: '2px dashed inkBorder', background: 'ink', cursor: 'pointer',
                UploadIcon: { tag: 'span', text: '⬆', fontSize: 'A', color: 'inkMuted' },
                UploadText: { text: 'Click to upload or drag & drop', fontSize: 'Y', color: 'inkMuted' },
                UploadHint: { text: 'PNG, JPG, DICOM, PDF — max 20MB each', fontSize: 'X', color: 'inkSubtle' }
              }
            },
            DocsField: {
              flow: 'y', gap: 'X', flex: '1', minWidth: '200px',
              DocsLabel: { tag: 'label', text: 'Reference Documents', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
              DocsSelect: {
                tag: 'select', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'ink',
                border: '1px solid inkBorder', color: 'inkText', width: '100%',
                children: [
                  { tag: 'option', text: '— Select document —' },
                  { tag: 'option', text: 'Treatment Plan Mar 2026' },
                  { tag: 'option', text: 'Lab Results Feb 2026' },
                  { tag: 'option', text: 'Referral Letter Jan 2026' },
                  { tag: 'option', text: 'Consent Form' },
                  { tag: 'option', text: 'Insurance Pre-auth' }
                ]
              },
              DocsNote: { text: 'Multiple docs can be referenced', fontSize: 'X', color: 'inkSubtle', marginTop: 'X' }
            }
          },

          // ── Referral Fields ─────────────────────
          ReferralBlock: {
            show: (el, s) => (s.root.newEventType || 'Consultation') === 'Referral',
            flow: 'y', gap: 'Z', padding: 'Z A', round: 'Y', background: 'ink', border: '1px solid inkBorder',
            RefTitle: { text: 'Referral Details', fontSize: 'Y', fontWeight: '700', color: 'inkText', marginBottom: 'X' },
            RefRow: { flow: 'x', gap: 'A', flexWrap: 'wrap',
              RefToField: { flow: 'y', gap: 'X', flex: '2', minWidth: '160px', RefToLabel: { tag: 'label', text: 'Referred To', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' }, RefToInput: { tag: 'input', type: 'text', placeholder: 'e.g. Dr. Ivane Lomidze', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' } },
              SpecField: { flow: 'y', gap: 'X', flex: '1', minWidth: '140px', SpecLabel: { tag: 'label', text: 'Specialty', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' }, SpecSelect: { tag: 'select', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%', children: [ { tag: 'option', text: 'Periodontics' }, { tag: 'option', text: 'Oral Surgery' }, { tag: 'option', text: 'Endodontics' }, { tag: 'option', text: 'Orthodontics' }, { tag: 'option', text: 'Prosthodontics' }, { tag: 'option', text: 'General Dentistry' } ] } },
              UrgField: { flow: 'y', gap: 'X', flex: '1', minWidth: '120px', UrgLabel: { tag: 'label', text: 'Urgency', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' }, UrgSelect: { tag: 'select', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%', children: [ { tag: 'option', text: 'Routine' }, { tag: 'option', text: 'Soon (2 weeks)' }, { tag: 'option', text: 'Urgent (48 hrs)' } ] } }
            },
            RefReasonField: { flow: 'y', gap: 'X', RefReasonLabel: { tag: 'label', text: 'Reason for Referral', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' }, RefReasonInput: { tag: 'textarea', placeholder: 'Clinical reason, findings, expected outcome…', fontSize: 'Z', padding: 'Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%', minHeight: 'E', resize: 'vertical', lineHeight: '1.6' } }
          },

          // ── Lab Result Fields ─────────────────────
          LabBlock: {
            show: (el, s) => (s.root.newEventType || 'Consultation') === 'Lab Result',
            flow: 'y', gap: 'Z', padding: 'Z A', round: 'Y', background: 'ink', border: '1px solid inkBorder',
            LabTitle: { text: 'Lab Result Details', fontSize: 'Y', fontWeight: '700', color: 'inkText', marginBottom: 'X' },
            LabRow1: { flow: 'x', gap: 'A', flexWrap: 'wrap',
              LoincField: { flow: 'y', gap: 'X', flex: '1', minWidth: '140px', LoincLabel: { tag: 'label', text: 'LOINC Code', fontSize: 'Y', fontWeight: '600', color: 'teal' }, LoincInput: { tag: 'input', type: 'text', placeholder: 'e.g. 2951-2', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid teal.30', color: 'inkText', width: '100%' } },
              LabNameField: { flow: 'y', gap: 'X', flex: '2', minWidth: '160px', LabNameLabel: { tag: 'label', text: 'Test Name', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' }, LabNameInput: { tag: 'input', type: 'text', placeholder: 'e.g. CBC, HbA1c', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' } },
              LabValField: { flow: 'y', gap: 'X', flex: '1', minWidth: '100px', LabValLabel: { tag: 'label', text: 'Result Value', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' }, LabValInput: { tag: 'input', type: 'text', placeholder: 'e.g. 5.4', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' } },
              LabRefField: { flow: 'y', gap: 'X', flex: '1', minWidth: '110px', LabRefLabel: { tag: 'label', text: 'Reference Range', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' }, LabRefInput: { tag: 'input', type: 'text', placeholder: 'e.g. 4.0–5.6', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' } }
            }
          },

          // ── Surgery Fields ─────────────────────────
          SurgeryBlock: {
            show: (el, s) => (s.root.newEventType || 'Consultation') === 'Surgery',
            flow: 'y', gap: 'Z', padding: 'Z A', round: 'Y', background: 'ink', border: '1px solid inkBorder',
            SurgTitle: { text: 'Surgery Details', fontSize: 'Y', fontWeight: '700', color: 'inkText', marginBottom: 'X' },
            SurgRow: { flow: 'x', gap: 'A', flexWrap: 'wrap',
              AnesField: { flow: 'y', gap: 'X', flex: '1', minWidth: '140px', AnesLabel: { tag: 'label', text: 'Anesthesia Type', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' }, AnesSelect: { tag: 'select', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%', children: [ { tag: 'option', text: 'Local' }, { tag: 'option', text: 'Local + Sedation' }, { tag: 'option', text: 'General' }, { tag: 'option', text: 'None' } ] } },
              SurgDurField: { flow: 'y', gap: 'X', flex: '1', minWidth: '110px', SDurLabel: { tag: 'label', text: 'Duration (min)', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' }, SDurInput: { tag: 'input', type: 'number', placeholder: '90', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' } },
              SurgTeamField: { flow: 'y', gap: 'X', flex: '2', minWidth: '160px', STeamLabel: { tag: 'label', text: 'Surgical Team', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' }, STeamInput: { tag: 'input', type: 'text', placeholder: 'e.g. Dr. Kvaratskhelia, Nurse Salome', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%' } }
            }
          },

          // ── Note simple ─────────────────────────────
          NoteBlock: {
            show: (el, s) => (s.root.newEventType || 'Consultation') === 'Note',
            flow: 'y', gap: 'X',
            NoteLabel: { tag: 'label', text: 'Note', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
            NoteInput: { tag: 'textarea', placeholder: 'Enter clinical note…', fontSize: 'Z', padding: 'Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', color: 'inkText', width: '100%', minHeight: 'F', resize: 'vertical', lineHeight: '1.6' }
          },

          // ── Visibility & Actions ─────────────────
          BottomRow: {
            flow: 'x', gap: 'A', align: 'center space-between', flexWrap: 'wrap', marginTop: 'Z',
            VisibilityRow: {
              flow: 'x', gap: 'Z', align: 'center flex-start',
              VisLabel: { text: 'Visibility:', fontSize: 'Z', fontWeight: '600', color: 'inkMuted' },
              VisToggle: {
                flow: 'x', gap: '0', round: 'Y', overflow: 'hidden', border: '1px solid inkBorder',
                PrivateBtn: {
                  text: '🔒 Private', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', cursor: 'pointer',
                  background: (el, s) => s.root.newEventVisibility !== 'shared' ? 'teal' : 'ink',
                  color: (el, s) => s.root.newEventVisibility !== 'shared' ? 'white' : 'inkMuted',
                  onClick: (e, el, s) => s.root.update({ newEventVisibility: 'private' })
                },
                SharedBtn: {
                  text: '👥 Shared', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', cursor: 'pointer',
                  background: (el, s) => s.root.newEventVisibility === 'shared' ? 'teal' : 'ink',
                  color: (el, s) => s.root.newEventVisibility === 'shared' ? 'white' : 'inkMuted',
                  onClick: (e, el, s) => s.root.update({ newEventVisibility: 'shared' })
                }
              }
            },
            PanelActions: {
              flow: 'x', gap: 'Z',
              CancelBtn: {
                text: 'Cancel', fontSize: 'Z', fontWeight: '600', padding: 'Y A', round: 'A',
                background: 'ink', border: '1px solid inkBorder', color: 'inkMuted', cursor: 'pointer',
                onClick: (e, el, s) => s.root.update({ addEventOpen: false })
              },
              SaveDraftBtn: {
                text: 'Save Draft', fontSize: 'Z', fontWeight: '600', padding: 'Y A', round: 'A',
                background: 'ink', border: '1px solid inkBorder', color: 'inkText', cursor: 'pointer',
                onClick: (e, el, s) => s.root.update({ addEventOpen: false })
              },
              SaveSyncBtn: {
                text: '↻ Save & Sync to EHR', fontSize: 'Z', fontWeight: '600', padding: 'Y A', round: 'A',
                background: 'teal', color: 'white', cursor: 'pointer',
                onClick: (e, el, s) => s.root.update({ addEventOpen: false })
              }
            }
          }
        },

        TimelineFilters: {
          flow: 'x', gap: 'Z', flexWrap: 'wrap', align: 'center flex-start',

          SearchBox: {
            flow: 'x', gap: 'Y', align: 'center center',
            flex: '1', minWidth: '200px', maxWidth: '320px',
            padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder',
            SearchIcon: { tag: 'span', text: '🔍', fontSize: 'Y' },
            SearchInput: { tag: 'input', type: 'text', placeholder: 'Search records…', fontSize: 'Z', background: 'transparent', border: 'none', color: 'inkText', outline: 'none', flex: '1' }
          },

          DateFromField: {
            flow: 'x', gap: 'Y', align: 'center center',
            padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder',
            DateFromLabel: { tag: 'span', text: 'From', fontSize: 'Y', color: 'inkMuted', whiteSpace: 'nowrap' },
            DateFromInput: { tag: 'input', type: 'date', fontSize: 'Y', background: 'transparent', border: 'none', color: 'inkText', outline: 'none' }
          },

          DateToField: {
            flow: 'x', gap: 'Y', align: 'center center',
            padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder',
            DateToLabel: { tag: 'span', text: 'To', fontSize: 'Y', color: 'inkMuted', whiteSpace: 'nowrap' },
            DateToInput: { tag: 'input', type: 'date', fontSize: 'Y', background: 'transparent', border: 'none', color: 'inkText', outline: 'none' }
          },

          DoctorFilter: {
            flow: 'x', gap: 'Y', align: 'center center',
            padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder',
            DoctorIcon: { tag: 'span', text: '👤', fontSize: 'Y' },
            DoctorSelect: {
              tag: 'select', fontSize: 'Y', background: 'transparent', border: 'none', color: 'inkText', outline: 'none', cursor: 'pointer',
              children: [
                { tag: 'option', text: 'All Doctors' },
                { tag: 'option', text: 'Dr. Kvaratskhelia' },
                { tag: 'option', text: 'Dr. Beridze' },
                { tag: 'option', text: 'Dr. Chikobava' }
              ]
            }
          },

          SortFilter: {
            flow: 'x', gap: 'Y', align: 'center center',
            padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder',
            SortIcon: { tag: 'span', text: '↕', fontSize: 'Y', color: 'inkMuted' },
            SortSelect: {
              tag: 'select', fontSize: 'Y', background: 'transparent', border: 'none', color: 'inkText', outline: 'none', cursor: 'pointer',
              children: [
                { tag: 'option', text: 'Newest First' },
                { tag: 'option', text: 'Oldest First' },
                { tag: 'option', text: 'By Type' },
                { tag: 'option', text: 'By Doctor' }
              ]
            }
          },

          // ── Type filter dropdown ────────────────────
          TypeFilterWrap: {
            position: 'relative',
            TypeFilterBtn: {
              flow: 'x', gap: 'Y', align: 'center center',
              padding: 'Y Z', round: 'Y', cursor: 'pointer',
              background: (el, s) => s.root.tlFilter ? 'teal.15' : 'inkMid',
              border: (el, s) => s.root.tlFilter ? '1px solid teal.30' : '1px solid inkBorder',
              onClick: (e, el, s) => { e.stopPropagation(); s.root.update({ typeFilterOpen: !s.root.typeFilterOpen }) },
              TypeBtnLabel: {
                tag: 'span', fontSize: 'Y', fontWeight: '600',
                color: (el, s) => s.root.tlFilter ? 'teal' : 'inkText',
                text: (el, s) => s.root.tlFilter ? s.root.tlFilter : 'Type'
              },
              TypeBtnArrow: { tag: 'span', text: '▾', fontSize: 'Y', color: 'inkMuted' }
            },
            TypeFilterMenu: {
              show: (el, s) => !!s.root.typeFilterOpen,
              position: 'absolute', top: '110%', left: '0', zIndex: '9999',
              background: 'inkMid', border: '1px solid inkBorder', borderRadius: 'A',
              overflow: 'hidden', minWidth: '180px', boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
              flow: 'y',
              TFAll: { text: 'All Types', fontSize: 'Z', padding: 'Y A', cursor: 'pointer', color: (el, s) => !s.root.tlFilter ? 'teal' : 'inkText', fontWeight: (el, s) => !s.root.tlFilter ? '700' : '400', onClick: (e, el, s) => s.root.update({ tlFilter: null, typeFilterOpen: false }) },
              TFSep: { height: '1px', background: 'inkBorder', margin: '0' },
              TFConsult: { text: '📋 Consultation', fontSize: 'Z', padding: 'Y A', cursor: 'pointer', color: (el, s) => s.root.tlFilter === 'Consultation' ? 'teal' : 'inkText', fontWeight: (el, s) => s.root.tlFilter === 'Consultation' ? '700' : '400', onClick: (e, el, s) => s.root.update({ tlFilter: 'Consultation', typeFilterOpen: false }) },
              TFTreatment: { text: '🦷 Treatment', fontSize: 'Z', padding: 'Y A', cursor: 'pointer', color: (el, s) => s.root.tlFilter === 'Treatment' ? 'teal' : 'inkText', fontWeight: (el, s) => s.root.tlFilter === 'Treatment' ? '700' : '400', onClick: (e, el, s) => s.root.update({ tlFilter: 'Treatment', typeFilterOpen: false }) },
              TFDiagnosis: { text: '🔬 Diagnosis', fontSize: 'Z', padding: 'Y A', cursor: 'pointer', color: (el, s) => s.root.tlFilter === 'Diagnosis' ? 'teal' : 'inkText', fontWeight: (el, s) => s.root.tlFilter === 'Diagnosis' ? '700' : '400', onClick: (e, el, s) => s.root.update({ tlFilter: 'Diagnosis', typeFilterOpen: false }) },
              TFPrescription: { text: '💊 Prescription', fontSize: 'Z', padding: 'Y A', cursor: 'pointer', color: (el, s) => s.root.tlFilter === 'Prescription' ? 'teal' : 'inkText', fontWeight: (el, s) => s.root.tlFilter === 'Prescription' ? '700' : '400', onClick: (e, el, s) => s.root.update({ tlFilter: 'Prescription', typeFilterOpen: false }) },
              TFImaging: { text: '🩻 Imaging', fontSize: 'Z', padding: 'Y A', cursor: 'pointer', color: (el, s) => s.root.tlFilter === 'Imaging' ? 'teal' : 'inkText', fontWeight: (el, s) => s.root.tlFilter === 'Imaging' ? '700' : '400', onClick: (e, el, s) => s.root.update({ tlFilter: 'Imaging', typeFilterOpen: false }) },
              TFLab: { text: '🧪 Lab Result', fontSize: 'Z', padding: 'Y A', cursor: 'pointer', color: (el, s) => s.root.tlFilter === 'Lab' ? 'teal' : 'inkText', fontWeight: (el, s) => s.root.tlFilter === 'Lab' ? '700' : '400', onClick: (e, el, s) => s.root.update({ tlFilter: 'Lab', typeFilterOpen: false }) },
              TFReferral: { text: '📤 Referral', fontSize: 'Z', padding: 'Y A', cursor: 'pointer', color: (el, s) => s.root.tlFilter === 'Referral' ? 'teal' : 'inkText', fontWeight: (el, s) => s.root.tlFilter === 'Referral' ? '700' : '400', onClick: (e, el, s) => s.root.update({ tlFilter: 'Referral', typeFilterOpen: false }) },
              TFSurgery: { text: '🔪 Surgery', fontSize: 'Z', padding: 'Y A', cursor: 'pointer', color: (el, s) => s.root.tlFilter === 'Surgery' ? 'teal' : 'inkText', fontWeight: (el, s) => s.root.tlFilter === 'Surgery' ? '700' : '400', onClick: (e, el, s) => s.root.update({ tlFilter: 'Surgery', typeFilterOpen: false }) },
              TFFollowup: { text: '↩ Follow-up', fontSize: 'Z', padding: 'Y A', cursor: 'pointer', color: (el, s) => s.root.tlFilter === 'Follow-up' ? 'teal' : 'inkText', fontWeight: (el, s) => s.root.tlFilter === 'Follow-up' ? '700' : '400', onClick: (e, el, s) => s.root.update({ tlFilter: 'Follow-up', typeFilterOpen: false }) },
              TFNote: { text: '📝 Note', fontSize: 'Z', padding: 'Y A', cursor: 'pointer', color: (el, s) => s.root.tlFilter === 'Note' ? 'teal' : 'inkText', fontWeight: (el, s) => s.root.tlFilter === 'Note' ? '700' : '400', onClick: (e, el, s) => s.root.update({ tlFilter: 'Note', typeFilterOpen: false }) }
            }
          }
        },

        TimelineLayout: {
          flow: 'x', gap: 'A', align: 'flex-start flex-start',

          TimelineList: {
            flow: 'y', gap: 'A', flex: '1', minWidth: '0',

            // ── CHAPTER 1 — Post-Treatment Follow-up ──────────────
            Chapter01: {
              flow: 'y', round: 'A', border: '1px solid teal.30', overflow: 'hidden',
              // Chapter Header
              Ch01Header: {
                flow: 'x', gap: 'Z', align: 'center space-between', cursor: 'pointer',
                padding: 'Z A', background: 'teal.08',
                onClick: (e, el, s) => s.root.update({ c01open: s.root.c01open === false ? true : false }),
                Ch01Left: {
                  flow: 'y', gap: 'X',
                  Ch01Title: { tag: 'h4', text: 'Post-Treatment Follow-up', fontSize: 'Z', fontWeight: '700', color: 'teal' },
                  Ch01Meta: { text: 'Mar 2026 · Dr. Kvaratskhelia · 1 visit', fontSize: 'Y', color: 'inkMuted' }
                },
                Ch01Right: {
                  flow: 'x', gap: 'Z', align: 'center center',
                  Ch01Badge: { tag: 'span', text: 'Follow-up', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'teal.15', color: 'teal' },
                  Ch01Chevron: { tag: 'span', text: (el, s) => s.root.c01open !== false ? '▾' : '▸', fontSize: 'Z', color: 'inkMuted', marginLeft: 'Y' }
                }
              },
              // Chapter Body
              Ch01Body: {
                show: (el, s) => s.root.c01open !== false,
                flow: 'y', gap: 'Y', padding: 'Z A', background: 'inkMid',
                // Visit 1
                Visit01: {
                  flow: 'y', gap: 'Y',
                  V01Header: {
                    flow: 'x', gap: 'Z', align: 'center flex-start',
                    V01DatePill: { tag: 'span', text: 'Mar 15, 2026', fontSize: 'Y', fontWeight: '700', padding: 'X Z', round: 'B', background: 'ink', color: 'teal' },
                    V01Info: { tag: 'span', text: '30 min · Dr. Kvaratskhelia', fontSize: 'Y', color: 'inkMuted', alignSelf: 'center' }
                  },
                  Entry01: {
                    flow: 'x', gap: 'Z', cursor: 'pointer',
                    background: (el, s) => s.root.selectedEntry === 'e01' ? 'teal.08' : 'transparent',
                    padding: 'Y Z', round: 'Y', margin: '0 -Z',
                    onClick: (e, el, s) => s.root.update({ selectedEntry: s.root.selectedEntry === 'e01' ? null : 'e01', seTitle: 'Follow-up Consultation', seDate: 'Mar 15, 2026', seDoctor: 'Dr. Kvaratskhelia', seType: 'Follow-up', seDuration: '30 min', seColor: 'teal', seDesc: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.', seTeeth: '#14', seVisibility: 'Shared' }),
                    CategoryDot: { width: 'Z', height: 'Z', round: 'Z', background: 'teal', flexShrink: '0', marginTop: 'Y' },
                    EntryContent: {
                      flow: 'y', gap: 'X', flex: '1',
                      EntryTitle: { text: 'Follow-up Consultation', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
                      EntryDesc: { text: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.', fontSize: 'Y', color: 'inkSubtle', lineHeight: '1.5' }
                    }
                  }
                },
                TpLink01: {
                  flow: 'x', gap: 'Z', align: 'center space-between',
                  padding: 'Y Z', round: 'Y', background: 'teal.06', border: '1px solid teal.20',
                  cursor: 'pointer', marginTop: 'Y',
                  onClick: (e, el, s) => s.root.update({ activePatientSection: 'treatmentPlan', selectedPhase: 'p4', tpCollP4: false }),
                  TpLink01Left: {
                    flow: 'x', gap: 'Z', align: 'center center',
                    TpLink01Icon: { extends: 'Icon', icon: 'clipboard', width: 'B', height: 'B', color: 'teal' },
                    TpLink01Text: { flow: 'y', gap: 'X',
                      TpLink01Label: { text: 'Treatment Plan', fontSize: 'X', fontWeight: '600', color: 'teal', textTransform: 'uppercase', letterSpacing: '0.05em' },
                      TpLink01Name: { text: 'Phase 4: Maintenance', fontSize: 'Y', fontWeight: '600', color: 'inkText' }
                    }
                  },
                  TpLink01Arrow: { extends: 'Icon', icon: 'arrowRight', width: 'B', height: 'B', color: 'teal' }
                }
              }
            },

            // ── CHAPTER 2 — Root Canal Treatment, Tooth #14 ────────
            Chapter02: {
              flow: 'y', round: 'A', border: '1px solid purple.30', overflow: 'hidden',
              Ch02Header: {
                flow: 'x', gap: 'Z', align: 'center space-between', cursor: 'pointer',
                padding: 'Z A', background: 'purple.08',
                onClick: (e, el, s) => s.root.update({ c02open: s.root.c02open === false ? true : false }),
                Ch02Left: {
                  flow: 'y', gap: 'X',
                  Ch02Title: { tag: 'h4', text: 'Root Canal Treatment — Tooth #14', fontSize: 'Z', fontWeight: '700', color: 'purple' },
                  Ch02Meta: { text: 'Mar 3 – Mar 10, 2026 · Dr. Kvaratskhelia · 4 visits', fontSize: 'Y', color: 'inkMuted' }
                },
                Ch02Right: {
                  flow: 'x', gap: 'Z', align: 'center center',
                  Ch02Badge: { tag: 'span', text: 'Treatment Episode', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'purple.15', color: 'purple' },
                  Ch02Chevron: { tag: 'span', text: (el, s) => s.root.c02open !== false ? '▾' : '▸', fontSize: 'Z', color: 'inkMuted', marginLeft: 'Y' }
                }
              },
              Ch02Body: {
                show: (el, s) => s.root.c02open !== false,
                flow: 'y', gap: 'A', padding: 'Z A', background: 'inkMid',
                // Visit A — Mar 10
                Visit02A: {
                  flow: 'y', gap: 'Y',
                  V02AHeader: {
                    flow: 'x', gap: 'Z', align: 'center flex-start',
                    V02ADatePill: { tag: 'span', text: 'Mar 10, 2026', fontSize: 'Y', fontWeight: '700', padding: 'X Z', round: 'B', background: 'ink', color: 'purple' },
                    V02AInfo: { tag: 'span', text: '90 min · Obturation Session', fontSize: 'Y', color: 'inkMuted', alignSelf: 'center' }
                  },
                  Entry02: {
                    flow: 'x', gap: 'Z', cursor: 'pointer',
                    background: (el, s) => s.root.selectedEntry === 'e02' ? 'purple.08' : 'transparent',
                    padding: 'Y Z', round: 'Y', margin: '0 -Z',
                    onClick: (e, el, s) => s.root.update({ selectedEntry: s.root.selectedEntry === 'e02' ? null : 'e02', seTitle: 'Root Canal Treatment — Phase 2', seDate: 'Mar 10, 2026', seDoctor: 'Dr. Kvaratskhelia', seType: 'Treatment', seDuration: '90 min', seColor: 'purple', seDesc: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.', seTeeth: '#14', seVisibility: 'Shared' }),
                    CategoryDot: { width: 'Z', height: 'Z', round: 'Z', background: 'purple', flexShrink: '0', marginTop: 'Y' },
                    EntryContent: {
                      flow: 'y', gap: 'X', flex: '1',
                      EntryTitle: { text: 'Root Canal Treatment — Phase 2', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
                      EntryDesc: { text: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.', fontSize: 'Y', color: 'inkSubtle', lineHeight: '1.5' }
                    }
                  }
                },
                VisitDivider1: { height: '1px', background: 'inkBorder' },
                // Visit B — Mar 8
                Visit02B: {
                  flow: 'y', gap: 'Y',
                  V02BHeader: {
                    flow: 'x', gap: 'Z', align: 'center flex-start',
                    V02BDatePill: { tag: 'span', text: 'Mar 8, 2026', fontSize: 'Y', fontWeight: '700', padding: 'X Z', round: 'B', background: 'ink', color: 'blue' },
                    V02BInfo: { tag: 'span', text: '15 min · Imaging', fontSize: 'Y', color: 'inkMuted', alignSelf: 'center' }
                  },
                  Entry03: {
                    flow: 'x', gap: 'Z', cursor: 'pointer',
                    background: (el, s) => s.root.selectedEntry === 'e03' ? 'blue.08' : 'transparent',
                    padding: 'Y Z', round: 'Y', margin: '0 -Z',
                    onClick: (e, el, s) => s.root.update({ selectedEntry: s.root.selectedEntry === 'e03' ? null : 'e03', seTitle: 'Periapical X-ray', seDate: 'Mar 8, 2026', seDoctor: 'Dr. Kvaratskhelia', seType: 'Imaging / Radiology', seDuration: '15 min', seColor: 'blue', seDesc: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.', seTeeth: '#14', seVisibility: 'Shared' }),
                    CategoryDot: { width: 'Z', height: 'Z', round: 'Z', background: 'blue', flexShrink: '0', marginTop: 'Y' },
                    EntryContent: {
                      flow: 'y', gap: 'X', flex: '1',
                      EntryTitle: { text: 'Periapical X-ray', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
                      EntryDesc: { text: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.', fontSize: 'Y', color: 'inkSubtle', lineHeight: '1.5' }
                    }
                  }
                },
                VisitDivider2: { height: '1px', background: 'inkBorder' },
                // Visit C — Mar 5
                Visit02C: {
                  flow: 'y', gap: 'Y',
                  V02CHeader: {
                    flow: 'x', gap: 'Z', align: 'center flex-start',
                    V02CDatePill: { tag: 'span', text: 'Mar 5, 2026', fontSize: 'Y', fontWeight: '700', padding: 'X Z', round: 'B', background: 'ink', color: 'amber' },
                    V02CInfo: { tag: 'span', text: '— · Prescription', fontSize: 'Y', color: 'inkMuted', alignSelf: 'center' }
                  },
                  Entry04: {
                    flow: 'x', gap: 'Z', cursor: 'pointer',
                    background: (el, s) => s.root.selectedEntry === 'e04' ? 'amber.08' : 'transparent',
                    padding: 'Y Z', round: 'Y', margin: '0 -Z',
                    onClick: (e, el, s) => s.root.update({ selectedEntry: s.root.selectedEntry === 'e04' ? null : 'e04', seTitle: 'Medication: Amoxicillin 500mg', seDate: 'Mar 5, 2026', seDoctor: 'Dr. Kvaratskhelia', seType: 'Prescription', seDuration: '—', seColor: 'amber', seDesc: 'Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy — confirmed Amoxicillin tolerance via skin test.', seTeeth: '#14', seVisibility: 'Shared' }),
                    CategoryDot: { width: 'Z', height: 'Z', round: 'Z', background: 'amber', flexShrink: '0', marginTop: 'Y' },
                    EntryContent: {
                      flow: 'y', gap: 'X', flex: '1',
                      EntryTitle: { text: 'Medication Prescribed: Amoxicillin 500mg', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
                      EntryDesc: { text: 'Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy — confirmed Amoxicillin tolerance via skin test.', fontSize: 'Y', color: 'inkSubtle', lineHeight: '1.5' }
                    }
                  }
                },
                VisitDivider3: { height: '1px', background: 'inkBorder' },
                // Visit D — Mar 3
                Visit02D: {
                  flow: 'y', gap: 'Y',
                  V02DHeader: {
                    flow: 'x', gap: 'Z', align: 'center flex-start',
                    V02DDatePill: { tag: 'span', text: 'Mar 3, 2026', fontSize: 'Y', fontWeight: '700', padding: 'X Z', round: 'B', background: 'ink', color: 'red' },
                    V02DInfo: { tag: 'span', text: '45 min · Diagnosis', fontSize: 'Y', color: 'inkMuted', alignSelf: 'center' }
                  },
                  Entry05: {
                    flow: 'x', gap: 'Z', cursor: 'pointer',
                    background: (el, s) => s.root.selectedEntry === 'e05' ? 'red.08' : 'transparent',
                    padding: 'Y Z', round: 'Y', margin: '0 -Z',
                    onClick: (e, el, s) => s.root.update({ selectedEntry: s.root.selectedEntry === 'e05' ? null : 'e05', seTitle: 'Diagnosis: Acute Pulpitis #14', seDate: 'Mar 3, 2026', seDoctor: 'Dr. Kvaratskhelia', seType: 'Diagnosis', seDuration: '45 min', seColor: 'red', seDesc: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.', seTeeth: '#14', seVisibility: 'Shared' }),
                    CategoryDot: { width: 'Z', height: 'Z', round: 'Z', background: 'red', flexShrink: '0', marginTop: 'Y' },
                    EntryContent: {
                      flow: 'y', gap: 'X', flex: '1',
                      EntryTitle: { text: 'Diagnosis: Acute Pulpitis #14', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
                      EntryDesc: { text: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.', fontSize: 'Y', color: 'inkSubtle', lineHeight: '1.5' }
                    }
                  }
                },
                TpLink02: {
                  flow: 'x', gap: 'Z', align: 'center space-between',
                  padding: 'Y Z', round: 'Y', background: 'purple.06', border: '1px solid purple.20',
                  cursor: 'pointer', marginTop: 'Y',
                  onClick: (e, el, s) => s.root.update({ activePatientSection: 'treatmentPlan', selectedPhase: 'p1', tpCollP1: false, tpCollP2: false }),
                  TpLink02Left: {
                    flow: 'x', gap: 'Z', align: 'center center',
                    TpLink02Icon: { extends: 'Icon', icon: 'clipboard', width: 'B', height: 'B', color: 'purple' },
                    TpLink02Text: { flow: 'y', gap: 'X',
                      TpLink02Label: { text: 'Treatment Plan', fontSize: 'X', fontWeight: '600', color: 'purple', textTransform: 'uppercase', letterSpacing: '0.05em' },
                      TpLink02Name: { text: 'Phase 1: Urgent/Emergency · Phase 2: Disease Control', fontSize: 'Y', fontWeight: '600', color: 'inkText' }
                    }
                  },
                  TpLink02Arrow: { extends: 'Icon', icon: 'arrowRight', width: 'B', height: 'B', color: 'purple' }
                }
              }
            },

            // ── CHAPTER 3 — Restorative Treatment ─────────────────
            Chapter03: {
              flow: 'y', round: 'A', border: '1px solid inkBorder', overflow: 'hidden',
              Ch03Header: {
                flow: 'x', gap: 'Z', align: 'center space-between', cursor: 'pointer',
                padding: 'Z A', background: 'ink',
                onClick: (e, el, s) => s.root.update({ c03open: s.root.c03open === false ? true : false }),
                Ch03Left: {
                  flow: 'y', gap: 'X',
                  Ch03Title: { tag: 'h4', text: 'Restorative Treatment', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
                  Ch03Meta: { text: 'Feb 2026 · Dr. Beridze · 1 visit', fontSize: 'Y', color: 'inkMuted' }
                },
                Ch03Right: {
                  flow: 'x', gap: 'Z', align: 'center center',
                  Ch03Badge: { tag: 'span', text: 'Restorative', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'purple.15', color: 'purple' },
                  Ch03Chevron: { tag: 'span', text: (el, s) => s.root.c03open !== false ? '▾' : '▸', fontSize: 'Z', color: 'inkMuted', marginLeft: 'Y' }
                }
              },
              Ch03Body: {
                show: (el, s) => s.root.c03open !== false,
                flow: 'y', gap: 'Y', padding: 'Z A', background: 'inkMid',
                Visit03: {
                  flow: 'y', gap: 'Y',
                  V03Header: {
                    flow: 'x', gap: 'Z', align: 'center flex-start',
                    V03DatePill: { tag: 'span', text: 'Feb 15, 2026', fontSize: 'Y', fontWeight: '700', padding: 'X Z', round: 'B', background: 'ink', color: 'purple' },
                    V03Info: { tag: 'span', text: '60 min · Dr. Beridze', fontSize: 'Y', color: 'inkMuted', alignSelf: 'center' }
                  },
                  Entry06: {
                    flow: 'x', gap: 'Z', cursor: 'pointer',
                    background: (el, s) => s.root.selectedEntry === 'e06' ? 'purple.08' : 'transparent',
                    padding: 'Y Z', round: 'Y', margin: '0 -Z',
                    onClick: (e, el, s) => s.root.update({ selectedEntry: s.root.selectedEntry === 'e06' ? null : 'e06', seTitle: 'Composite Filling — Tooth #21', seDate: 'Feb 15, 2026', seDoctor: 'Dr. Beridze', seType: 'Treatment', seDuration: '60 min', seColor: 'purple', seDesc: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.', seTeeth: '#21', seVisibility: 'Shared' }),
                    CategoryDot: { width: 'Z', height: 'Z', round: 'Z', background: 'purple', flexShrink: '0', marginTop: 'Y' },
                    EntryContent: {
                      flow: 'y', gap: 'X', flex: '1',
                      EntryTitle: { text: 'Composite Filling — Tooth #21', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
                      EntryDesc: { text: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.', fontSize: 'Y', color: 'inkSubtle', lineHeight: '1.5' }
                    }
                  }
                },
                TpLink03: {
                  flow: 'x', gap: 'Z', align: 'center space-between',
                  padding: 'Y Z', round: 'Y', background: 'blue.06', border: '1px solid blue.20',
                  cursor: 'pointer', marginTop: 'Y',
                  onClick: (e, el, s) => s.root.update({ activePatientSection: 'treatmentPlan', selectedPhase: 'p3', tpCollP3: false }),
                  TpLink03Left: {
                    flow: 'x', gap: 'Z', align: 'center center',
                    TpLink03Icon: { extends: 'Icon', icon: 'clipboard', width: 'B', height: 'B', color: 'blue' },
                    TpLink03Text: { flow: 'y', gap: 'X',
                      TpLink03Label: { text: 'Treatment Plan', fontSize: 'X', fontWeight: '600', color: 'blue', textTransform: 'uppercase', letterSpacing: '0.05em' },
                      TpLink03Name: { text: 'Phase 3: Restorative', fontSize: 'Y', fontWeight: '600', color: 'inkText' }
                    }
                  },
                  TpLink03Arrow: { extends: 'Icon', icon: 'arrowRight', width: 'B', height: 'B', color: 'blue' }
                }
              }
            },

            // ── CHAPTER 4 — Initial Consultation ──────────────────
            Chapter04: {
              flow: 'y', round: 'A', border: '1px solid inkBorder', overflow: 'hidden',
              Ch04Header: {
                flow: 'x', gap: 'Z', align: 'center space-between', cursor: 'pointer',
                padding: 'Z A', background: 'ink',
                onClick: (e, el, s) => s.root.update({ c04open: s.root.c04open === false ? true : false }),
                Ch04Left: {
                  flow: 'y', gap: 'X',
                  Ch04Title: { tag: 'h4', text: 'Initial Consultation & Exam', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
                  Ch04Meta: { text: 'Jan 2026 · Dr. Kvaratskhelia · 1 visit', fontSize: 'Y', color: 'inkMuted' }
                },
                Ch04Right: {
                  flow: 'x', gap: 'Z', align: 'center center',
                  Ch04Badge: { tag: 'span', text: 'Exam', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'teal.15', color: 'teal' },
                  Ch04Chevron: { tag: 'span', text: (el, s) => s.root.c04open !== false ? '▾' : '▸', fontSize: 'Z', color: 'inkMuted', marginLeft: 'Y' }
                }
              },
              Ch04Body: {
                show: (el, s) => s.root.c04open !== false,
                flow: 'y', gap: 'Y', padding: 'Z A', background: 'inkMid',
                Visit04: {
                  flow: 'y', gap: 'Y',
                  V04Header: {
                    flow: 'x', gap: 'Z', align: 'center flex-start',
                    V04DatePill: { tag: 'span', text: 'Jan 20, 2026', fontSize: 'Y', fontWeight: '700', padding: 'X Z', round: 'B', background: 'ink', color: 'teal' },
                    V04Info: { tag: 'span', text: '90 min · Dr. Kvaratskhelia', fontSize: 'Y', color: 'inkMuted', alignSelf: 'center' }
                  },
                  Entry07: {
                    flow: 'x', gap: 'Z', cursor: 'pointer',
                    background: (el, s) => s.root.selectedEntry === 'e07' ? 'teal.08' : 'transparent',
                    padding: 'Y Z', round: 'Y', margin: '0 -Z',
                    onClick: (e, el, s) => s.root.update({ selectedEntry: s.root.selectedEntry === 'e07' ? null : 'e07', seTitle: 'Comprehensive Examination', seDate: 'Jan 20, 2026', seDoctor: 'Dr. Kvaratskhelia', seType: 'Consultation', seDuration: '90 min', seColor: 'teal', seDesc: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.', seTeeth: 'Full mouth', seVisibility: 'Shared' }),
                    CategoryDot: { width: 'Z', height: 'Z', round: 'Z', background: 'teal', flexShrink: '0', marginTop: 'Y' },
                    EntryContent: {
                      flow: 'y', gap: 'X', flex: '1',
                      EntryTitle: { text: 'Comprehensive Examination', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
                      EntryDesc: { text: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.', fontSize: 'Y', color: 'inkSubtle', lineHeight: '1.5' }
                    }
                  }
                },
                TpLink04: {
                  flow: 'x', gap: 'Z', align: 'center space-between',
                  padding: 'Y Z', round: 'Y', background: 'inkSurface', border: '1px solid inkBorder',
                  cursor: 'pointer', marginTop: 'Y',
                  onClick: (e, el, s) => s.root.update({ activePatientSection: 'treatmentPlan', selectedPhase: 'p2', tpCollP1: false, tpCollP2: false }),
                  TpLink04Left: {
                    flow: 'x', gap: 'Z', align: 'center center',
                    TpLink04Icon: { extends: 'Icon', icon: 'clipboard', width: 'B', height: 'B', color: 'inkMuted' },
                    TpLink04Text: { flow: 'y', gap: 'X',
                      TpLink04Label: { text: 'Treatment Plan', fontSize: 'X', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: '0.05em' },
                      TpLink04Name: { text: 'Phase 1: Urgent/Emergency · Phase 2: Disease Control', fontSize: 'Y', fontWeight: '600', color: 'inkText' }
                    }
                  },
                  TpLink04Arrow: { extends: 'Icon', icon: 'arrowRight', width: 'B', height: 'B', color: 'inkMuted' }
                }
              }
            }
          },

          // ─── Entry Detail Panel (EHR form, pre-filled) ──
          EntryDetailPanel: {
            show: (el, s) => !!s.root.selectedEntry,
            flow: 'y', gap: 'Z', width: 'H', flexShrink: '0',
            padding: 'A', round: 'A', background: 'inkMid',
            border: (el, s) => `1px solid ${s.root.seColor || 'teal'}`,
            position: 'sticky', top: 'A', overflow: 'auto', maxHeight: '85vh',

            DPanelHeader: {
              flow: 'x', align: 'center space-between', marginBottom: 'Z',
              DPanelLeft: {
                flow: 'y', gap: 'X',
                DTypeBadge: {
                  tag: 'span', text: (el, s) => s.root.seType || 'Record',
                  fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B',
                  background: (el, s) => `${s.root.seColor || 'teal'}.15`,
                  color: (el, s) => s.root.seColor || 'teal'
                },
                DSubtitle: { text: 'View / Edit Record', fontSize: 'X', color: 'inkMuted' }
              },
              DCloseBtn: { tag: 'span', text: '✕', fontSize: 'Z', color: 'inkMuted', cursor: 'pointer', padding: 'Y', onClick: (e, el, s) => s.root.update({ selectedEntry: null }) }
            },

            // ── EHR Sync ─────────────────────────────
            DEhrBlock: {
              flow: 'y', gap: 'Z', padding: 'Z A', round: 'Y', background: 'ink', border: '1px solid inkBorder', marginBottom: 'Z',
              DEhrTitle: { text: 'EHR / System Sync', fontSize: 'Y', fontWeight: '700', color: 'teal', marginBottom: 'X' },
              DEhrRow: {
                flow: 'x', gap: 'Z', flexWrap: 'wrap',
                DEhrSys: { flow: 'y', gap: 'X', flex: '1', minWidth: '120px', DEhrSysL: { tag: 'label', text: 'EHR System', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, DEhrSysV: { tag: 'select', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%', children: [{ tag: 'option', text: '— None —' }, { tag: 'option', text: 'Epic' }, { tag: 'option', text: 'OpenDental' }, { tag: 'option', text: 'Dentrix' }] } },
                DSyncSt: { flow: 'y', gap: 'X', flex: '1', minWidth: '100px', DSyncStL: { tag: 'label', text: 'Sync Status', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, DSyncStV: { tag: 'select', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%', children: [{ tag: 'option', text: 'Not Synced' }, { tag: 'option', text: 'Sync on Save' }] } }
              }
            },

            // ── Core Fields ──────────────────────────
            DCoreRow1: {
              flow: 'x', gap: 'Z', flexWrap: 'wrap', marginBottom: 'Z',
              DTypeField: { flow: 'y', gap: 'X', flex: '1', minWidth: '120px', DTypeL: { tag: 'label', text: 'Event Type *', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, DTypeV: { tag: 'input', type: 'text', value: (el, s) => s.root.seType || '', placeholder: 'Type', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', color: 'inkText', width: '100%' } },
              DDateField: { flow: 'y', gap: 'X', flex: '1', minWidth: '110px', DDateL: { tag: 'label', text: 'Date *', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, DDateV: { tag: 'input', type: 'text', value: (el, s) => s.root.seDate || '', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', color: 'inkText', width: '100%' } }
            },
            DCoreRow2: {
              flow: 'x', gap: 'Z', flexWrap: 'wrap', marginBottom: 'Z',
              DDoctField: { flow: 'y', gap: 'X', flex: '1', minWidth: '130px', DDoctL: { tag: 'label', text: 'Doctor *', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, DDoctV: { tag: 'input', type: 'text', value: (el, s) => s.root.seDoctor || '', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', color: 'inkText', width: '100%' } },
              DTeethField: { flow: 'y', gap: 'X', flex: '1', minWidth: '90px', DTeethL: { tag: 'label', text: 'Teeth', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, DTeethV: { tag: 'input', type: 'text', value: (el, s) => s.root.seTeeth || '', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', color: 'inkText', width: '100%' } },
              DDurField: { flow: 'y', gap: 'X', flex: '1', minWidth: '90px', DDurL: { tag: 'label', text: 'Duration', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, DDurV: { tag: 'input', type: 'text', value: (el, s) => s.root.seDuration || '', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', color: 'inkText', width: '100%' } }
            },
            DTitleField: { flow: 'y', gap: 'X', marginBottom: 'Z', DTitleL: { tag: 'label', text: 'Title *', fontSize: 'Y', color: 'inkMuted', fontWeight: '600' }, DTitleV: { tag: 'input', type: 'text', value: (el, s) => s.root.seTitle || '', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', color: 'inkText', width: '100%' } },

            // ── Clinical Notes (SOAP) ────────────────
            DSoapBlock: {
              flow: 'y', gap: 'Z', padding: 'Z A', round: 'Y', background: 'ink', border: '1px solid inkBorder', marginBottom: 'Z',
              DSoapTitle: { text: 'Clinical Notes', fontSize: 'Y', fontWeight: '700', color: 'inkMuted', marginBottom: 'X' },
              DSoapText: { tag: 'textarea', value: (el, s) => s.root.seDesc || '', fontSize: 'Z', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', width: '100%', rows: '5', lineHeight: '1.6', placeholder: 'Clinical notes, SOAP...' }
            },

            // ── Visibility + Actions ─────────────────
            DVisRow: {
              flow: 'x', gap: 'Z', align: 'center flex-start', marginBottom: 'Z',
              DVisLabel: { tag: 'span', text: 'Visibility:', fontSize: 'Y', color: 'inkMuted', fontWeight: '600', alignSelf: 'center' },
              DPrivBtn: {
                tag: 'span', text: 'Private', fontSize: 'Y', padding: 'X Z', round: 'B', cursor: 'pointer',
                fontWeight: (el, s) => s.root.seVisibility === 'Private' ? '700' : '400',
                background: (el, s) => s.root.seVisibility === 'Private' ? 'ink' : 'transparent',
                border: (el, s) => s.root.seVisibility === 'Private' ? '1px solid inkBorder' : '1px solid transparent',
                color: 'inkText',
                onClick: (e, el, s) => s.root.update({ seVisibility: 'Private' })
              },
              DSharedBtn: {
                tag: 'span', text: 'Shared', fontSize: 'Y', padding: 'X Z', round: 'B', cursor: 'pointer',
                fontWeight: (el, s) => s.root.seVisibility !== 'Private' ? '700' : '400',
                background: (el, s) => s.root.seVisibility !== 'Private' ? 'teal.15' : 'transparent',
                border: (el, s) => s.root.seVisibility !== 'Private' ? '1px solid teal.30' : '1px solid transparent',
                color: (el, s) => s.root.seVisibility !== 'Private' ? 'teal' : 'inkMuted',
                onClick: (e, el, s) => s.root.update({ seVisibility: 'Shared' })
              }
            },
            DActions: {
              flow: 'x', gap: 'Y', flexWrap: 'wrap',
              DCancelBtn: { text: 'Close', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', color: 'inkMuted', cursor: 'pointer', flex: '1', textAlign: 'center', onClick: (e, el, s) => s.root.update({ selectedEntry: null }) },
              DPrintBtn: { text: 'Print', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', color: 'inkText', cursor: 'pointer', flex: '1', textAlign: 'center' },
              DSaveBtn: { text: '↻ Save & Sync', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', round: 'Y', background: 'teal', color: 'white', cursor: 'pointer', flex: '1', textAlign: 'center' }
            }
          }
        }
      },

      // ═══════════════════════════════════════════════
      // 2. CHART (Odontogram)
      // ═══════════════════════════════════════════════
      ChartSection: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.activePatientSection === 'chart',

        ChartLayout: {
          flow: 'x', gap: 'A', align: 'stretch flex-start',
          '@mobileL': { flow: 'y' },

          OdontogramSection: {
            flow: 'y', gap: 'A', flex: '1',

            ChartLegend: {},

            OdontogramGrid: {},

            ProcedureButtonBar: {
              flow: 'x', gap: 'Y', flexWrap: 'wrap', padding: 'Z 0',
              children: [
                { name: 'Periodic Exam', code: 'D0120' },
                { name: 'FMX', code: 'D0210' },
                { name: 'Bitewings', code: 'D0274' },
                { name: 'Prophylaxis', code: 'D1110' },
                { name: 'Composite', code: 'D2391' },
                { name: 'Crown', code: 'D2750' },
                { name: 'Root Canal', code: 'D3310' },
                { name: 'SRP', code: 'D4341' },
                { name: 'Extraction', code: 'D7140' }
              ],
              childrenAs: 'state',
              childExtends: 'ProcedureButton'
            }
          },

          ToothDetailPanel: {
            show: (el, s) => s.root.selectedTooth !== null
          }
        },

        // ─── Chart History ─────────────────────────────
        ChartHistorySection: {
          flow: 'y', gap: 'Z', marginTop: 'A',
          HistoryHeader: {
            flow: 'x', gap: 'A', align: 'center space-between',
            HistoryTitle: { tag: 'h3', text: 'Chart History', fontSize: 'A', fontWeight: '700', color: 'inkText' },
            HistorySubtitle: { text: 'Odontogram snapshots over time', fontSize: 'Y', color: 'inkMuted', alignSelf: 'center' }
          },
          HistoryTabs: {
            flow: 'x', gap: 'Z', borderBottom: '1px solid inkBorder', paddingBottom: 'Y',
            TabMar2026: {
              text: 'Mar 2026', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer',
              color: (el, s) => s.root.chartHistTab !== 'jan2026' && s.root.chartHistTab !== 'initial' ? 'teal' : 'inkMuted',
              borderBottom: (el, s) => s.root.chartHistTab !== 'jan2026' && s.root.chartHistTab !== 'initial' ? '2px solid teal' : '2px solid transparent',
              onClick: (e, el, s) => s.root.update({ chartHistTab: 'mar2026' })
            },
            TabJan2026: {
              text: 'Jan 2026', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer',
              color: (el, s) => s.root.chartHistTab === 'jan2026' ? 'teal' : 'inkMuted',
              borderBottom: (el, s) => s.root.chartHistTab === 'jan2026' ? '2px solid teal' : '2px solid transparent',
              onClick: (e, el, s) => s.root.update({ chartHistTab: 'jan2026' })
            },
            TabInitial: {
              text: 'Initial (Jan 2026)', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer',
              color: (el, s) => s.root.chartHistTab === 'initial' ? 'teal' : 'inkMuted',
              borderBottom: (el, s) => s.root.chartHistTab === 'initial' ? '2px solid teal' : '2px solid transparent',
              onClick: (e, el, s) => s.root.update({ chartHistTab: 'initial' })
            }
          },
          HistorySnapshot: {
            flow: 'y', gap: 'A', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
            SnapshotMeta: {
              flow: 'x', gap: 'A', align: 'center flex-start', flexWrap: 'wrap',
              SnapDate: {
                text: (el, s) => s.root.chartHistTab === 'jan2026' ? 'Jan 20, 2026 · Initial Exam' : s.root.chartHistTab === 'initial' ? 'Jan 20, 2026 · Baseline' : 'Mar 10, 2026 · Latest',
                fontSize: 'Z', fontWeight: '700', color: 'inkText'
              },
              SnapDoctor: {
                text: (el, s) => s.root.chartHistTab === 'jan2026' || s.root.chartHistTab === 'initial' ? 'Dr. Kvaratskhelia' : 'Dr. Lomidze',
                fontSize: 'Y', color: 'inkMuted', alignSelf: 'center'
              }
            },
            SnapChanges: {
              flow: 'y', gap: 'Y',
              ChangesLabel: { text: 'Changes from this visit:', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
              ChangesList: {
                flow: 'y', gap: 'X',
                C1: {
                  show: (el, s) => s.root.chartHistTab !== 'jan2026' && s.root.chartHistTab !== 'initial',
                  flow: 'x', gap: 'Y', align: 'center flex-start',
                  Dot: { width: 'X', height: 'X', round: 'X', background: 'purple', flexShrink: '0', marginTop: 'X' },
                  Txt: { tag: 'span', text: 'Crown prep on #14 — PFM crown cemented', fontSize: 'Y', color: 'inkSubtle' }
                },
                C2: {
                  show: (el, s) => s.root.chartHistTab !== 'jan2026' && s.root.chartHistTab !== 'initial',
                  flow: 'x', gap: 'Y', align: 'center flex-start',
                  Dot: { width: 'X', height: 'X', round: 'X', background: 'amber', flexShrink: '0', marginTop: 'X' },
                  Txt: { tag: 'span', text: 'Root canal completed on #14', fontSize: 'Y', color: 'inkSubtle' }
                },
                C3: {
                  show: (el, s) => s.root.chartHistTab === 'jan2026' || s.root.chartHistTab === 'initial',
                  flow: 'x', gap: 'Y', align: 'center flex-start',
                  Dot: { width: 'X', height: 'X', round: 'X', background: 'red', flexShrink: '0', marginTop: 'X' },
                  Txt: { tag: 'span', text: 'Caries detected: #14 occlusal, #15 mesial', fontSize: 'Y', color: 'inkSubtle' }
                },
                C4: {
                  show: (el, s) => s.root.chartHistTab === 'jan2026' || s.root.chartHistTab === 'initial',
                  flow: 'x', gap: 'Y', align: 'center flex-start',
                  Dot: { width: 'X', height: 'X', round: 'X', background: 'amber', flexShrink: '0', marginTop: 'X' },
                  Txt: { tag: 'span', text: 'Perio pockets 4mm+ on 24 sites — Stage III Grade B', fontSize: 'Y', color: 'inkSubtle' }
                }
              }
            },
            OdontogramGrid: {}
          }
        }
      },

      // ═══════════════════════════════════════════════
      // 3. PERIO
      // ═══════════════════════════════════════════════
      PerioSection: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.activePatientSection === 'perio',

        PerioHeader: {
          flow: 'x', gap: 'A', align: 'center space-between', flexWrap: 'wrap',
          '@mobileL': { flow: 'y', gap: 'Z' },

          HeaderLeft: {
            flow: 'x', gap: 'A', align: 'center flex-start',
            PageTitle: { tag: 'h3', text: '{{ periodontalChart | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
            PerioExamSelector: {}
          },

          HeaderRight: {
            flow: 'x', gap: 'Z', align: 'center flex-start',
            NewExamBtn: {
              extends: 'Button', text: '{{ newExam2 | polyglot }}',
              background: 'teal', color: 'inkText', fontWeight: '600',
              padding: 'Y A', round: 'A', fontSize: 'Z', cursor: 'pointer', border: 'none'
            },
            VoiceToggle: {
              flow: 'x', gap: 'Y', align: 'center center', padding: 'Y A', round: 'A', cursor: 'pointer',
              background: (el, s) => s.root.voiceEntry ? 'purple' : 'inkMid',
              border: (el, s) => s.root.voiceEntry ? '1px solid purple' : '1px solid inkBorder',
              onClick: (e, el, s) => s.root.update({ voiceEntry: !s.root.voiceEntry }),
              MicIcon: { extends: 'Icon', icon: 'microphone', width: 'Z', height: 'Z', color: (el, s) => s.root.voiceEntry ? 'inkText' : 'inkMuted' },
              VoiceLabel: { text: '{{ voiceEntry2 | polyglot }}', fontSize: 'Z', fontWeight: '600', color: (el, s) => s.root.voiceEntry ? 'inkText' : 'inkMuted' }
            }
          }
        },

        PerioGrid: {},

        PerioIndexCards: {
          state: {
            bleeding: 18,
            plaque: 12,
            sitesFourPlus: 24,
            sitesSixPlus: 6
          }
        },

        PerioAiInsight: {
          extends: 'AiInsightCard',
          state: {
            insight: 'Based on current exam: AAP Stage III, Grade B periodontitis. 6 sites show progression. Recommend: SRP quadrants 1,4. Re-evaluate in 4-6 weeks.',
            confidence: '89'
          }
        }
      },

      // ═══════════════════════════════════════════════
      // 4. TREATMENT PLAN
      // ═══════════════════════════════════════════════
      TreatmentPlanSection: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.activePatientSection === 'treatmentPlan',

        PlanHeader: {
          flow: 'x', gap: 'A', align: 'center space-between', flexWrap: 'wrap',
          '@mobileL': { flow: 'y', gap: 'Z' },
          PageTitle: { tag: 'h3', text: '{{ treatmentPlan | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
          ChairSideToggle: {
            extends: 'Button',
            flow: 'x', gap: 'Y', align: 'center center',
            padding: 'Y Z', round: 'C', cursor: 'pointer', fontWeight: '600', fontSize: 'Y',
            border: (el, s) => s.root.chairSideMode ? '1px solid teal' : '1px solid inkBorder',
            background: (el, s) => s.root.chairSideMode ? 'teal.15' : 'inkSurface',
            color: (el, s) => s.root.chairSideMode ? 'teal' : 'inkMuted',
            transition: 'all 0.2s ease',
            ToggleIcon: {
              extends: 'Icon',
              icon: (el, s) => s.root.chairSideMode ? 'eye' : 'eyeOff',
              fontSize: 'Z'
            },
            Label: {
              text: (el, s) => s.root.chairSideMode ? '{{ chairSideMode | polyglot }}' : '{{ adminMode | polyglot }}'
            },
            onClick: (e, el, s) => s.root.update({ chairSideMode: !s.root.chairSideMode })
          }
        },

        PlanSelector: {
          flow: 'x', gap: 'Z', borderBottom: '1px solid inkBorder', paddingBottom: 'Y',
          TabPlanA: {
            text: '{{ planARecommended | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer',
            color: (el, s) => s.root.activePlan === 'planA' ? 'teal' : 'inkMuted',
            borderBottom: (el, s) => s.root.activePlan === 'planA' ? '2px solid teal' : '2px solid transparent',
            onClick: (e, el, s) => s.root.update({ activePlan: 'planA' })
          },
          TabPlanB: {
            text: '{{ planBConservative | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer',
            color: (el, s) => s.root.activePlan === 'planB' ? 'teal' : 'inkMuted',
            borderBottom: (el, s) => s.root.activePlan === 'planB' ? '2px solid teal' : '2px solid transparent',
            onClick: (e, el, s) => s.root.update({ activePlan: 'planB' })
          },
          TabNewPlan: {
            text: '{{ newPlan2 | polyglot }}', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer', color: 'inkMuted'
          }
        },

        PlanAView: {
          flow: 'y', gap: 'A',
          show: (el, s) => s.root.activePlan !== 'planB',

          // ── Two-column layout (phases + timeline summary) ──
          PlanLayout: {
            flow: 'x', gap: 'A', align: 'flex-start flex-start',

            PhaseColumn: {
              flow: 'y', gap: 'A', flex: '1', minWidth: '0',

              // ── PHASE 1 ──────────────────────────────────
              Phase1Card: {
                flow: 'y', round: 'A', overflow: 'hidden',
                border: '1px solid teal',
                PhaseHeader1: {
                  flow: 'x', align: 'center space-between', padding: 'Z A', cursor: 'pointer',
                  background: 'teal.08',
                  onClick: (e, el, s) => s.root.update({ selectedPhase: s.root.selectedPhase === 'p1' ? null : 'p1', tpCollP1: !s.root.tpCollP1 }),
                  PhLeft1: {
                    flow: 'y', gap: 'X',
                    PhTitle1: { tag: 'h4', text: 'Phase 1: Urgent/Emergency', fontSize: 'Z', fontWeight: '700', color: 'teal' },
                    PhMeta1: { text: '2 procedures · Dr. Lomidze', fontSize: 'Y', color: 'inkMuted' }
                  },
                  PhRight1: {
                    flow: 'x', gap: 'Z', align: 'center center',
                    PhBadge1: { tag: 'span', text: 'active', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'teal.15', color: 'teal' },
                    PhChev1: { tag: 'span', text: (el, s) => s.root.tpCollP1 ? '▸' : '▾', fontSize: 'Z', color: 'inkMuted', marginLeft: 'Y' }
                  }
                },
                PhBody1: {
                  show: (el, s) => !s.root.tpCollP1,
                  flow: 'y', background: 'inkMid', borderTop: '1px solid inkBorder',
                  Row1: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', borderBottom: '1px solid inkBorder', R1Code: { tag: 'span', text: 'D7140', fontSize: 'Y', fontWeight: '700', color: 'teal', width: 'E', flexShrink: '0' }, R1Desc: { flex: '1', text: 'Extraction #36', fontSize: 'Z', color: 'inkText' }, R1Tooth: { tag: 'span', text: '#36', fontSize: 'Y', color: 'inkMuted', width: 'D' }, R1Fee: { tag: 'span', text: '₾150', fontSize: 'Z', fontWeight: '700', color: 'teal' } },
                  Row2: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', R2Code: { tag: 'span', text: 'D2950', fontSize: 'Y', fontWeight: '700', color: 'teal', width: 'E', flexShrink: '0' }, R2Desc: { flex: '1', text: 'Core Buildup #14', fontSize: 'Z', color: 'inkText' }, R2Tooth: { tag: 'span', text: '#14', fontSize: 'Y', color: 'inkMuted', width: 'D' }, R2Fee: { tag: 'span', text: '₾120', fontSize: 'Z', fontWeight: '700', color: 'teal' } },
                  PhSum1: { flow: 'x', align: 'center space-between', padding: 'Y A', background: 'inkSurface', borderTop: '1px solid inkBorder', SumLbl: { text: 'Phase Total', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' }, SumRight: { flow: 'x', gap: 'A', SumAmt: { text: '₾270', fontSize: 'Z', fontWeight: '700', color: 'teal' }, SumCnt: { text: '2 procedures', fontSize: 'Y', color: 'inkMuted' } } }
                }
              },

              // ── PHASE 2 ──────────────────────────────────
              Phase2Card: {
                flow: 'y', round: 'A', overflow: 'hidden', border: '1px solid inkBorder',
                PhaseHeader2: {
                  flow: 'x', align: 'center space-between', padding: 'Z A', cursor: 'pointer', background: 'ink',
                  onClick: (e, el, s) => s.root.update({ selectedPhase: s.root.selectedPhase === 'p2' ? null : 'p2', tpCollP2: !s.root.tpCollP2 }),
                  PhLeft2: { flow: 'y', gap: 'X', PhTitle2: { tag: 'h4', text: 'Phase 2: Disease Control', fontSize: 'Z', fontWeight: '700', color: 'inkText' }, PhMeta2: { text: '3 procedures · Dr. Kvaratskhelia', fontSize: 'Y', color: 'inkMuted' } },
                  PhRight2: { flow: 'x', gap: 'Z', align: 'center center', PhBadge2: { tag: 'span', text: 'pending', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'inkMid', color: 'inkMuted' }, PhChev2: { tag: 'span', text: (el, s) => s.root.tpCollP2 ? '▸' : '▾', fontSize: 'Z', color: 'inkMuted', marginLeft: 'Y' } }
                },
                PhBody2: {
                  show: (el, s) => !s.root.tpCollP2,
                  flow: 'y', background: 'inkMid', borderTop: '1px solid inkBorder',
                  Row3: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', borderBottom: '1px solid inkBorder', R3Code: { tag: 'span', text: 'D4341', fontSize: 'Y', fontWeight: '700', color: 'teal', width: 'E', flexShrink: '0' }, R3Desc: { flex: '1', text: 'SRP Quadrant 1', fontSize: 'Z', color: 'inkText' }, R3Tooth: { tag: 'span', text: 'Q1', fontSize: 'Y', color: 'inkMuted', width: 'D' }, R3Fee: { tag: 'span', text: '₾200', fontSize: 'Z', fontWeight: '700', color: 'teal' } },
                  Row4: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', borderBottom: '1px solid inkBorder', R4Code: { tag: 'span', text: 'D4341', fontSize: 'Y', fontWeight: '700', color: 'teal', width: 'E', flexShrink: '0' }, R4Desc: { flex: '1', text: 'SRP Quadrant 4', fontSize: 'Z', color: 'inkText' }, R4Tooth: { tag: 'span', text: 'Q4', fontSize: 'Y', color: 'inkMuted', width: 'D' }, R4Fee: { tag: 'span', text: '₾200', fontSize: 'Z', fontWeight: '700', color: 'teal' } },
                  Row5: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', R5Code: { tag: 'span', text: 'D4910', fontSize: 'Y', fontWeight: '700', color: 'teal', width: 'E', flexShrink: '0' }, R5Desc: { flex: '1', text: 'Perio Maintenance', fontSize: 'Z', color: 'inkText' }, R5Tooth: { tag: 'span', text: 'Full', fontSize: 'Y', color: 'inkMuted', width: 'D' }, R5Fee: { tag: 'span', text: '₾80', fontSize: 'Z', fontWeight: '700', color: 'teal' } },
                  PhSum2: { flow: 'x', align: 'center space-between', padding: 'Y A', background: 'inkSurface', borderTop: '1px solid inkBorder', SumLbl: { text: 'Phase Total', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' }, SumRight: { flow: 'x', gap: 'A', SumAmt: { text: '₾480', fontSize: 'Z', fontWeight: '700', color: 'teal' }, SumCnt: { text: '3 procedures', fontSize: 'Y', color: 'inkMuted' } } }
                }
              },

              // ── PHASE 3 ──────────────────────────────────
              Phase3Card: {
                flow: 'y', round: 'A', overflow: 'hidden', border: '1px solid inkBorder',
                PhaseHeader3: {
                  flow: 'x', align: 'center space-between', padding: 'Z A', cursor: 'pointer', background: 'ink',
                  onClick: (e, el, s) => s.root.update({ selectedPhase: s.root.selectedPhase === 'p3' ? null : 'p3', tpCollP3: !s.root.tpCollP3 }),
                  PhLeft3: { flow: 'y', gap: 'X', PhTitle3: { tag: 'h4', text: 'Phase 3: Restorative', fontSize: 'Z', fontWeight: '700', color: 'inkText' }, PhMeta3: { text: '3 procedures · Dr. Lomidze, Dr. Beridze', fontSize: 'Y', color: 'inkMuted' } },
                  PhRight3: { flow: 'x', gap: 'Z', align: 'center center', PhBadge3: { tag: 'span', text: 'pending', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'inkMid', color: 'inkMuted' }, PhChev3: { tag: 'span', text: (el, s) => s.root.tpCollP3 ? '▸' : '▾', fontSize: 'Z', color: 'inkMuted', marginLeft: 'Y' } }
                },
                PhBody3: {
                  show: (el, s) => !s.root.tpCollP3,
                  flow: 'y', background: 'inkMid', borderTop: '1px solid inkBorder',
                  Row6: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', borderBottom: '1px solid inkBorder', R6Code: { tag: 'span', text: 'D2750', fontSize: 'Y', fontWeight: '700', color: 'teal', width: 'E', flexShrink: '0' }, R6Desc: { flex: '1', text: 'Crown #14', fontSize: 'Z', color: 'inkText' }, R6Tooth: { tag: 'span', text: '#14', fontSize: 'Y', color: 'inkMuted', width: 'D' }, R6Fee: { tag: 'span', text: '₾800', fontSize: 'Z', fontWeight: '700', color: 'teal' } },
                  Row7: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', borderBottom: '1px solid inkBorder', R7Code: { tag: 'span', text: 'D6010', fontSize: 'Y', fontWeight: '700', color: 'teal', width: 'E', flexShrink: '0' }, R7Desc: { flex: '1', text: 'Implant #36', fontSize: 'Z', color: 'inkText' }, R7Tooth: { tag: 'span', text: '#36', fontSize: 'Y', color: 'inkMuted', width: 'D' }, R7Fee: { tag: 'span', text: '₾1,200', fontSize: 'Z', fontWeight: '700', color: 'teal' } },
                  Row8: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', R8Code: { tag: 'span', text: 'D6058', fontSize: 'Y', fontWeight: '700', color: 'teal', width: 'E', flexShrink: '0' }, R8Desc: { flex: '1', text: 'Implant Crown #36', fontSize: 'Z', color: 'inkText' }, R8Tooth: { tag: 'span', text: '#36', fontSize: 'Y', color: 'inkMuted', width: 'D' }, R8Fee: { tag: 'span', text: '₾600', fontSize: 'Z', fontWeight: '700', color: 'teal' } },
                  PhSum3: { flow: 'x', align: 'center space-between', padding: 'Y A', background: 'inkSurface', borderTop: '1px solid inkBorder', SumLbl: { text: 'Phase Total', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' }, SumRight: { flow: 'x', gap: 'A', SumAmt: { text: '₾2,600', fontSize: 'Z', fontWeight: '700', color: 'teal' }, SumCnt: { text: '3 procedures', fontSize: 'Y', color: 'inkMuted' } } }
                }
              },

              // ── PHASE 4 ──────────────────────────────────
              Phase4Card: {
                flow: 'y', round: 'A', overflow: 'hidden', border: '1px solid inkBorder',
                PhaseHeader4: {
                  flow: 'x', align: 'center space-between', padding: 'Z A', cursor: 'pointer', background: 'ink',
                  onClick: (e, el, s) => s.root.update({ selectedPhase: s.root.selectedPhase === 'p4' ? null : 'p4', tpCollP4: !s.root.tpCollP4 }),
                  PhLeft4: { flow: 'y', gap: 'X', PhTitle4: { tag: 'h4', text: 'Phase 4: Maintenance', fontSize: 'Z', fontWeight: '700', color: 'inkText' }, PhMeta4: { text: '3 procedures · Multiple providers', fontSize: 'Y', color: 'inkMuted' } },
                  PhRight4: { flow: 'x', gap: 'Z', align: 'center center', PhBadge4: { tag: 'span', text: 'pending', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'inkMid', color: 'inkMuted' }, PhChev4: { tag: 'span', text: (el, s) => s.root.tpCollP4 ? '▸' : '▾', fontSize: 'Z', color: 'inkMuted', marginLeft: 'Y' } }
                },
                PhBody4: {
                  show: (el, s) => !s.root.tpCollP4,
                  flow: 'y', background: 'inkMid', borderTop: '1px solid inkBorder',
                  Row9:  { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', borderBottom: '1px solid inkBorder', R9Code: { tag: 'span', text: 'D0120', fontSize: 'Y', fontWeight: '700', color: 'teal', width: 'E', flexShrink: '0' }, R9Desc: { flex: '1', text: 'Periodic Exam', fontSize: 'Z', color: 'inkText' }, R9Tooth: { tag: 'span', text: 'Full', fontSize: 'Y', color: 'inkMuted', width: 'D' }, R9Fee: { tag: 'span', text: '₾30', fontSize: 'Z', fontWeight: '700', color: 'teal' } },
                  Row10: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', borderBottom: '1px solid inkBorder', R10Code: { tag: 'span', text: 'D1110', fontSize: 'Y', fontWeight: '700', color: 'teal', width: 'E', flexShrink: '0' }, R10Desc: { flex: '1', text: 'Prophylaxis', fontSize: 'Z', color: 'inkText' }, R10Tooth: { tag: 'span', text: 'Full', fontSize: 'Y', color: 'inkMuted', width: 'D' }, R10Fee: { tag: 'span', text: '₾50', fontSize: 'Z', fontWeight: '700', color: 'teal' } },
                  Row11: { flow: 'x', gap: 'Z', align: 'center flex-start', padding: 'Y A', R11Code: { tag: 'span', text: 'D0274', fontSize: 'Y', fontWeight: '700', color: 'teal', width: 'E', flexShrink: '0' }, R11Desc: { flex: '1', text: 'BWX', fontSize: 'Z', color: 'inkText' }, R11Tooth: { tag: 'span', text: 'Full', fontSize: 'Y', color: 'inkMuted', width: 'D' }, R11Fee: { tag: 'span', text: '₾40', fontSize: 'Z', fontWeight: '700', color: 'teal' } },
                  PhSum4: { flow: 'x', align: 'center space-between', padding: 'Y A', background: 'inkSurface', borderTop: '1px solid inkBorder', SumLbl: { text: 'Phase Total', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' }, SumRight: { flow: 'x', gap: 'A', SumAmt: { text: '₾120', fontSize: 'Z', fontWeight: '700', color: 'teal' }, SumCnt: { text: '3 procedures', fontSize: 'Y', color: 'inkMuted' } } }
                }
              },

              TreatmentSummaryBar: {
                state: { totalFee: 3470, insuranceCoverage: 2776, patientPortion: 694, currency: '₾' }
              },
              AiInsightCard: {
                state: { insight: 'Recommended sequencing: Complete Phase 1 extraction and buildup first, then SRP for disease control. Wait 3-4 months post-extraction before implant placement in #36. Crown #14 can proceed after SRP completion.', confidence: '92' }
              }
            },

            // ── Phase → Timeline link panel ───────────────
            PhaseTimelinePanel: {
              show: (el, s) => !!s.root.selectedPhase,
              flow: 'y', gap: 'Z', width: 'H', flexShrink: '0',
              padding: 'A', round: 'A', background: 'inkMid',
              border: '1px solid teal.30', position: 'sticky', top: 'A',

              PanelTopRow: {
                flow: 'x', align: 'center space-between', marginBottom: 'Z',
                PanelHead: {
                  flow: 'y', gap: 'X',
                  PanelLabel: { text: 'Timeline Summary', fontSize: 'Y', fontWeight: '700', color: 'teal' },
                  PanelPhaseName: {
                    text: (el, s) => {
                      var p = s.root.selectedPhase
                      if (p === 'p1') return 'Phase 1: Urgent/Emergency'
                      if (p === 'p2') return 'Phase 2: Disease Control'
                      if (p === 'p3') return 'Phase 3: Restorative'
                      return 'Phase 4: Maintenance'
                    },
                    fontSize: 'Z', fontWeight: '600', color: 'inkText'
                  }
                },
                ClosePhase: { tag: 'span', text: '✕', fontSize: 'Z', color: 'inkMuted', cursor: 'pointer', onClick: (e, el, s) => s.root.update({ selectedPhase: null }) }
              },

              RelatedEntries: {
                flow: 'y', gap: 'Y', paddingTop: 'Z', borderTop: '1px solid inkBorder',
                RelLabel: { text: 'Related visits from history:', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', marginBottom: 'X' },

                // Phase 1 entries
                P1Entries: {
                  show: (el, s) => s.root.selectedPhase === 'p1',
                  flow: 'y', gap: 'Y',
                  E1: { flow: 'y', gap: 'X', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', EDate: { text: 'Mar 3, 2026', fontSize: 'Y', color: 'red', fontWeight: '600' }, ETitle: { text: 'Diagnosis: Acute Pulpitis #14', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, EDesc: { text: 'Triggered extraction & buildup planning for #14', fontSize: 'Y', color: 'inkSubtle' } }
                },

                // Phase 2 entries
                P2Entries: {
                  show: (el, s) => s.root.selectedPhase === 'p2',
                  flow: 'y', gap: 'Y',
                  E2: { flow: 'y', gap: 'X', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', EDate: { text: 'Jan 20, 2026', fontSize: 'Y', color: 'teal', fontWeight: '600' }, ETitle: { text: 'Comprehensive Examination', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, EDesc: { text: 'Stage III Grade B periodontitis identified — SRP indicated for Q1 & Q4', fontSize: 'Y', color: 'inkSubtle' } }
                },

                // Phase 3 entries
                P3Entries: {
                  show: (el, s) => s.root.selectedPhase === 'p3',
                  flow: 'y', gap: 'Y',
                  E3: { flow: 'y', gap: 'X', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', EDate: { text: 'Mar 10, 2026', fontSize: 'Y', color: 'purple', fontWeight: '600' }, ETitle: { text: 'Root Canal Treatment — Phase 2', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, EDesc: { text: 'Obturation complete — Crown #14 scheduled post-SRP', fontSize: 'Y', color: 'inkSubtle' } },
                  E3b: { flow: 'y', gap: 'X', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', EDate: { text: 'Feb 15, 2026', fontSize: 'Y', color: 'purple', fontWeight: '600' }, ETitle: { text: 'Composite Filling — Tooth #21', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, EDesc: { text: 'Prior restorative work completed successfully', fontSize: 'Y', color: 'inkSubtle' } }
                },

                // Phase 4 entries
                P4Entries: {
                  show: (el, s) => s.root.selectedPhase === 'p4',
                  flow: 'y', gap: 'Y',
                  E4: { flow: 'y', gap: 'X', padding: 'Y Z', round: 'Y', background: 'ink', border: '1px solid inkBorder', EDate: { text: 'Mar 15, 2026', fontSize: 'Y', color: 'teal', fontWeight: '600' }, ETitle: { text: 'Follow-up Consultation', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, EDesc: { text: 'Maintenance protocol initiated — next recall in 3 months', fontSize: 'Y', color: 'inkSubtle' } }
                }
              }
            }
          }
        },

        PlanBView: {
          flow: 'y', gap: 'A',
          show: (el, s) => s.root.activePlan === 'planB',

          ConservativeNote: {
            flow: 'y', gap: 'Z', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
            NoteTitle: { text: '{{ conservativeApproach | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'amber' },
            NoteDesc: { text: '{{ thisPlanPrioritizesDisease | polyglot }}', fontSize: 'Z', color: 'inkMuted', lineHeight: '1.6' }
          },

          ConservativePhases: {
            flow: 'y', gap: 'A',
            children: [
              {
                title: 'Phase 1: Disease Control',
                phase: 1,
                status: 'active',
                rows: [
                  { code: 'D4341', description: 'SRP Quadrant 1', tooth: 'Q1', provider: 'Dr. Kvaratskhelia', fee: 200, status: 'planned' },
                  { code: 'D4341', description: 'SRP Quadrant 4', tooth: 'Q4', provider: 'Dr. Kvaratskhelia', fee: 200, status: 'planned' },
                  { code: 'D4910', description: 'Perio Maintenance', tooth: 'Full', provider: 'Dr. Kvaratskhelia', fee: 80, status: 'planned' }
                ]
              },
              {
                title: 'Phase 2: Re-evaluation & Restorative',
                phase: 2,
                status: 'pending',
                rows: [
                  { code: 'D0120', description: 'Periodic Exam', tooth: 'Full', provider: 'Dr. Lomidze', fee: 30, status: 'planned' },
                  { code: 'D2950', description: 'Core Buildup #14', tooth: '#14', provider: 'Dr. Lomidze', fee: 120, status: 'planned' },
                  { code: 'D2750', description: 'Crown #14', tooth: '#14', provider: 'Dr. Lomidze', fee: 800, status: 'planned' }
                ]
              },
              {
                title: 'Phase 3: Maintenance',
                phase: 3,
                status: 'pending',
                rows: [
                  { code: 'D1110', description: 'Prophylaxis', tooth: 'Full', provider: 'Dr. Kvaratskhelia', fee: 50, status: 'planned' },
                  { code: 'D0274', description: 'BWX', tooth: 'Full', provider: 'Dr. Lomidze', fee: 40, status: 'planned' }
                ]
              }
            ],
            childrenAs: 'state',
            childExtends: 'TreatmentPhase'
          },

          TreatmentSummaryBar: {
            state: {
              totalFee: 1520,
              insuranceCoverage: 1216,
              patientPortion: 304,
              currency: '₾'
            }
          }
        }
      },

      // ═══════════════════════════════════════════════
      // 5. NOTES (Clinical Notes) — REMOVED
      // ═══════════════════════════════════════════════
      NotesSection: {
        show: false,

        NotesHeader: {
          flow: 'x', gap: 'A', align: 'center space-between', flexWrap: 'wrap',
          '@mobileL': { flow: 'y', gap: 'Z' },
          PageTitle: { tag: 'h3', text: '{{ clinicalNotes | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
          NewNoteBtn: {
            extends: 'Button', text: '{{ newNote | polyglot }}',
            background: 'teal', color: 'inkText', fontWeight: '600',
            padding: 'Y A', round: 'A', fontSize: 'Z', cursor: 'pointer', border: 'none'
          }
        },

        TwoPanelLayout: {
          flow: 'x', gap: 'A', align: 'stretch flex-start', flex: '1',
          '@mobileL': { flow: 'y' },

          NotesTimeline: {
            flow: 'y', gap: 'Z', width: 'G', flexShrink: '0',
            '@mobileL': { width: '100%' },

            children: [
              {
                date: 'Mar 10, 2026',
                provider: 'Dr. Lomidze',
                procedure: 'Crown Prep',
                summary: 'Tooth #14 prepared for PFM crown. Impression taken. Temporary crown placed. Patient tolerated procedure well.',
                noteIndex: 0
              },
              {
                date: 'Feb 15, 2026',
                provider: 'Dr. Lomidze',
                procedure: 'Root Canal Completion',
                summary: 'RCT #14 completed. 3 canals identified and obturated. Post-op periapical radiograph confirmed adequate fill.',
                noteIndex: 1
              },
              {
                date: 'Jan 20, 2026',
                provider: 'Dr. Kvaratskhelia',
                procedure: 'Periodic Exam',
                summary: 'Periodic exam. Caries detected on #14 occlusal, #15 mesial. Perio probing stable. Treatment plan discussed.',
                noteIndex: 2
              },
              {
                date: 'Nov 5, 2025',
                provider: 'Dr. Kvaratskhelia',
                procedure: 'Prophylaxis',
                summary: 'Routine prophylaxis performed. Light calculus removed. OHI reinforced. Fluoride varnish applied.',
                noteIndex: 3
              },
              {
                date: 'Sep 15, 2025',
                provider: 'Dr. Lomidze',
                procedure: 'Perio Exam',
                summary: 'Full periodontal examination. BPE scores recorded. Multiple 4-5mm pockets in Q1 and Q4. SRP recommended.',
                noteIndex: 4
              }
            ],
            childrenAs: 'state',
            childExtends: 'ClinicalNoteCard'
          },

          NoteEditor: {
            flow: 'y', gap: 'A', flex: '1', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder',

            NoteTemplateBar: {
              flow: 'x', gap: 'Z', align: 'center flex-start', flexWrap: 'wrap', marginBottom: 'Z',
              TemplateLabel: { text: '{{ template | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkMuted' },
              NoteTemplate: {
                state: {
                  templates: [
                    { label: 'SOAP Note', value: 'soap' },
                    { label: 'Procedure Note', value: 'procedure' },
                    { label: 'Exam Note', value: 'exam' },
                    { label: 'Perio Note', value: 'perio' },
                    { label: 'Consult Note', value: 'consult' }
                  ]
                }
              }
            },

            EditorTitle: {
              flow: 'x', gap: 'Z', align: 'center flex-start', marginBottom: 'Z',
              NoteDate: { text: 'Mar 10, 2026', fontSize: 'A', fontWeight: '700', color: 'teal' },
              NoteProcedure: { text: '{{ crownPrep | polyglot }}', fontSize: 'A', fontWeight: '600', color: 'inkMuted' }
            },

            SoapNote: {
              state: {
                subjective: 'Patient reports no pain since last visit. Temporary restoration intact. Ready for crown preparation.',
                objective: 'Tooth #14: Temporary filling intact. No percussion sensitivity. Periapical radiograph shows adequate root canal fill. Gingival tissue healthy around #14.',
                assessment: 'Tooth #14 status post-RCT, ready for crown preparation. No signs of infection or failure.',
                plan: 'PFM crown preparation #14. Final impression with PVS material. Fabricate temporary crown. Schedule crown delivery in 2 weeks.',
                provider: 'Dr. Lomidze',
                date: 'Mar 10, 2026'
              }
            },

            AiScribePanel: {
              flow: 'y', gap: 'Z', padding: 'A', round: 'A', background: 'inkSurface', border: '1px solid inkBorder', marginTop: 'Z',

              ScribeHeader: {
                flow: 'x', gap: 'Y', align: 'center flex-start',
                SparkleIcon: { extends: 'Icon', icon: 'sparkle', width: 'Z', height: 'Z', color: 'purple' },
                ScribeTitle: { text: '{{ aiScribe | polyglot }}', fontSize: 'Z', fontWeight: '700', color: 'purple' }
              },

              ScribeDesc: {
                text: '{{ recordYourClinicalEncounter | polyglot }}',
                fontSize: 'Z', color: 'inkMuted', lineHeight: '1.5', marginTop: 'Y'
              },

              ScribeActions: {
                flow: 'x', gap: 'Z', marginTop: 'Z', flexWrap: 'wrap',
                RecordBtn: {
                  extends: 'Button',
                  flow: 'x', gap: 'Y', align: 'center center',
                  background: 'purple', color: 'inkText', fontWeight: '600',
                  padding: 'Y A', round: 'A', fontSize: 'Z', cursor: 'pointer', border: 'none',
                  MicIcon: { extends: 'Icon', icon: 'microphone', width: 'Z', height: 'Z', color: 'inkText' },
                  BtnLabel: { text: '{{ startRecording | polyglot }}' }
                },
                GenerateBtn: {
                  extends: 'Button',
                  flow: 'x', gap: 'Y', align: 'center center',
                  background: 'inkMid', color: 'inkText', fontWeight: '600',
                  padding: 'Y A', round: 'A', fontSize: 'Z', cursor: 'pointer', border: '1px solid inkBorder',
                  GenIcon: { extends: 'Icon', icon: 'sparkle', width: 'Z', height: 'Z', color: 'purple' },
                  BtnLabel: { text: '{{ generateNote | polyglot }}' }
                }
              }
            }
          }
        }
      },

      // ═══════════════════════════════════════════════
      // 6. MEDICAL HISTORY
      // ═══════════════════════════════════════════════
      MedHistorySection: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.activePatientSection === 'medHistory',

        // ─── Conditions ───────────────────────────
        ConditionsView: {
          flow: 'y', gap: 'A',
          show: (el, s) => s.root.medHistorySubTab === 'conditions',

          ConditionsTitle: { tag: 'h3', text: '{{ activeConditions | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },

          CondCard1: {
            flow: 'y', gap: 'Y', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
            CondHeader: { flow: 'x', align: 'center space-between', CondName: { text: '{{ chronicPeriodontitis | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, CondBadge: { text: '{{ active | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'red.15', color: 'red' } },
            CondCode: { text: 'ICD-10: K05.31', fontSize: 'Y', color: 'teal', fontWeight: '500' },
            CondDesc: { text: '{{ generalizedMildChronicPeriodon | polyglot }}', fontSize: 'Z', color: 'inkMuted', lineHeight: '1.5' },
            CondMeta: { flow: 'x', gap: 'A', CondOnset: { text: '{{ onsetJan2026 | polyglot }}', fontSize: 'Y', color: 'inkMuted' }, CondProvider: { text: 'Dr. Kvaratskhelia', fontSize: 'Y', color: 'inkMuted' } }
          },
          CondCard2: {
            flow: 'y', gap: 'Y', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
            CondHeader: { flow: 'x', align: 'center space-between', CondName: { text: '{{ dentalCaries | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, CondBadge: { text: '{{ resolved | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'green.15', color: 'green' } },
            CondCode: { text: 'ICD-10: K02.9', fontSize: 'Y', color: 'teal', fontWeight: '500' },
            CondDesc: { text: '{{ cariousLesionOnTooth | polyglot }}', fontSize: 'Z', color: 'inkMuted', lineHeight: '1.5' },
            CondMeta: { flow: 'x', gap: 'A', CondOnset: { text: '{{ onsetJan2026 | polyglot }}', fontSize: 'Y', color: 'inkMuted' }, CondResolved: { text: '{{ resolvedFeb2026 | polyglot }}', fontSize: 'Y', color: 'green' } }
          },
          CondCard3: {
            flow: 'y', gap: 'Y', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
            CondHeader: { flow: 'x', align: 'center space-between', CondName: { text: '{{ bruxism | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, CondBadge: { text: '{{ active | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'amber.15', color: 'amber' } },
            CondCode: { text: 'ICD-10: G47.63', fontSize: 'Y', color: 'teal', fontWeight: '500' },
            CondDesc: { text: '{{ nocturnalBruxismWearFacets | polyglot }}', fontSize: 'Z', color: 'inkMuted', lineHeight: '1.5' },
            CondMeta: { flow: 'x', gap: 'A', CondOnset: { text: '{{ onsetJan2026 | polyglot }}', fontSize: 'Y', color: 'inkMuted' }, CondProvider: { text: 'Dr. Lomidze', fontSize: 'Y', color: 'inkMuted' } }
          }
        },

        // ─── Medications ──────────────────────────
        MedicationsView: {
          flow: 'y', gap: 'A',
          show: (el, s) => s.root.medHistorySubTab === 'medications',

          ActiveMedsTitle: { tag: 'h3', text: '{{ activeMedications | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },

          MedActive1: {
            flow: 'x', gap: 'A', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', align: 'center flex-start',
            MedInfo: { flow: 'y', gap: 'X', flex: '1', MedName: { text: '{{ lisinopril10mg | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, MedDosage: { text: '{{ onceDailyOral | polyglot }}', fontSize: 'Y', color: 'inkMuted' }, MedReason: { text: '{{ hypertensionManagement | polyglot }}', fontSize: 'Y', color: 'inkSubtle' } },
            MedBadge: { text: '{{ active | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'green.15', color: 'green' }
          },
          MedActive2: {
            flow: 'x', gap: 'A', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', align: 'center flex-start',
            MedInfo: { flow: 'y', gap: 'X', flex: '1', MedName: { text: '{{ chlorhexidine012Rinse | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, MedDosage: { text: '{{ twiceDailyOralRinse | polyglot }}', fontSize: 'Y', color: 'inkMuted' }, MedReason: { text: '{{ periodontalMaintenance | polyglot }}', fontSize: 'Y', color: 'inkSubtle' } },
            MedBadge: { text: '{{ active | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'green.15', color: 'green' }
          },
          MedActive3: {
            flow: 'x', gap: 'A', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', align: 'center flex-start',
            MedInfo: { flow: 'y', gap: 'X', flex: '1', MedName: { text: '{{ ibuprofen400mg | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, MedDosage: { text: '{{ asNeededForPain | polyglot }}', fontSize: 'Y', color: 'inkMuted' }, MedReason: { text: '{{ postprocedurePainManagement | polyglot }}', fontSize: 'Y', color: 'inkSubtle' } },
            MedBadge: { text: '{{ active | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'green.15', color: 'green' }
          },

          PastMedsTitle: { tag: 'h3', text: '{{ pastMedications | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText', marginTop: 'A' },

          MedPast1: {
            flow: 'x', gap: 'A', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', align: 'center flex-start', opacity: '0.7',
            MedInfo: { flow: 'y', gap: 'X', flex: '1', MedName: { text: '{{ amoxicillin500mg | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, MedDosage: { text: '3x daily for 7 days (Mar 5-12, 2026)', fontSize: 'Y', color: 'inkMuted' }, MedReason: { text: '{{ periapicalInfectionProphylaxis | polyglot }}', fontSize: 'Y', color: 'inkSubtle' } },
            MedBadge: { text: '{{ completed2 | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'inkSurface', color: 'inkMuted' }
          },
          MedPast2: {
            flow: 'x', gap: 'A', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', align: 'center flex-start', opacity: '0.7',
            MedInfo: { flow: 'y', gap: 'X', flex: '1', MedName: { text: '{{ metronidazole250mg | polyglot }}', fontSize: 'Z', fontWeight: '600', color: 'inkText' }, MedDosage: { text: '3x daily for 5 days (Feb 20-25, 2026)', fontSize: 'Y', color: 'inkMuted' }, MedReason: { text: '{{ adjunctPeriodontalTherapy | polyglot }}', fontSize: 'Y', color: 'inkSubtle' } },
            MedBadge: { text: '{{ completed2 | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'inkSurface', color: 'inkMuted' }
          }
        },

        // ─── Allergies ────────────────────────────
        AllergiesView: {
          flow: 'y', gap: 'A',
          show: (el, s) => s.root.medHistorySubTab === 'allergies',

          AllergiesTitle: { tag: 'h3', text: '{{ documentedAllergies | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },

          AllergyPenicillin: {
            flow: 'y', gap: 'Y', padding: 'A', round: 'A', background: 'inkMid', border: '2px solid red',
            AllergyHeader: { flow: 'x', align: 'center space-between', AllergyName: { text: '{{ penicillin | polyglot }}', fontSize: 'Z', fontWeight: '700', color: 'inkText' }, SeverityBadge: { text: '{{ severe | polyglot }}', fontSize: 'Y', fontWeight: '700', padding: 'X Z', round: 'B', background: 'red.15', color: 'red' } },
            AllergyReaction: { text: '{{ reactionAnaphylaxisUrticariaAn | polyglot }}', fontSize: 'Z', color: 'inkSubtle', lineHeight: '1.5' },
            AllergyNote: { text: '{{ crossreactivityWithCephalospor | polyglot }}', fontSize: 'Y', color: 'inkMuted', lineHeight: '1.5' },
            AllergyDate: { text: '{{ documentedJan102026 | polyglot }}', fontSize: 'Y', color: 'inkMuted' }
          },
          AllergyLatex: {
            flow: 'y', gap: 'Y', padding: 'A', round: 'A', background: 'inkMid', border: '2px solid amber',
            AllergyHeader: { flow: 'x', align: 'center space-between', AllergyName: { text: '{{ latex | polyglot }}', fontSize: 'Z', fontWeight: '700', color: 'inkText' }, SeverityBadge: { text: '{{ moderate | polyglot }}', fontSize: 'Y', fontWeight: '700', padding: 'X Z', round: 'B', background: 'amber.15', color: 'amber' } },
            AllergyReaction: { text: '{{ reactionContactDermatitisLocal | polyglot }}', fontSize: 'Z', color: 'inkSubtle', lineHeight: '1.5' },
            AllergyNote: { text: '{{ useNitrileGlovesOnly | polyglot }}', fontSize: 'Y', color: 'inkMuted', lineHeight: '1.5' },
            AllergyDate: { text: '{{ documentedJan102026 | polyglot }}', fontSize: 'Y', color: 'inkMuted' }
          },
          AllergyLidocaine: {
            flow: 'y', gap: 'Y', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
            AllergyHeader: { flow: 'x', align: 'center space-between', AllergyName: { text: '{{ lidocaine | polyglot }}', fontSize: 'Z', fontWeight: '700', color: 'inkText' }, SeverityBadge: { text: '{{ mild | polyglot }}', fontSize: 'Y', fontWeight: '700', padding: 'X Z', round: 'B', background: 'inkSurface', color: 'inkMuted' } },
            AllergyReaction: { text: '{{ reactionMildTinglingProlonged | polyglot }}', fontSize: 'Z', color: 'inkSubtle', lineHeight: '1.5' },
            AllergyNote: { text: '{{ useArticaineAsAlternative | polyglot }}', fontSize: 'Y', color: 'inkMuted', lineHeight: '1.5' },
            AllergyDate: { text: '{{ documentedJan102026 | polyglot }}', fontSize: 'Y', color: 'inkMuted' }
          }
        },

        // ─── Vitals ───────────────────────────────
        VitalsView: {
          flow: 'y', gap: 'A',
          show: (el, s) => s.root.medHistorySubTab === 'vitals',

          VitalsTitle: { tag: 'h3', text: '{{ latestVitalsMar15 | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },

          VitalsRow: {
            flow: 'x', gap: 'A', flexWrap: 'wrap', '@mobileL': { flow: 'y' },
            CardBP: { extends: 'StatCard', state: { label: 'Blood Pressure', value: '128/82', unit: 'mmHg', status: 'elevated' } },
            CardHR: { extends: 'StatCard', state: { label: 'Heart Rate', value: '72', unit: 'bpm', status: 'normal' } },
            CardTemp: { extends: 'StatCard', state: { label: 'Temperature', value: '36.8', unit: '°C', status: 'normal' } },
            CardO2: { extends: 'StatCard', state: { label: 'O2 Saturation', value: '98', unit: '%', status: 'normal' } },
            CardWeight: { extends: 'StatCard', state: { label: 'Weight', value: '78', unit: 'kg', status: 'normal' } }
          }
        },

        // ─── Imaging ──────────────────────────────
        ImagingView: {
          flow: 'y', gap: 'A',
          show: (el, s) => s.root.medHistorySubTab === 'imaging',

          ImagingTitle: { tag: 'h3', text: '{{ imagingRecords | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },

          ImagingGrid: {
            flow: 'x', flexWrap: 'wrap', gap: 'A', '@mobileL': { flow: 'y' },
            Img1: { flow: 'y', gap: 'Y', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E', ImgPlaceholder: { width: '100%', height: 'E', background: 'inkSurface', round: 'Y', flow: 'x', align: 'center center', ImgLabel: { text: '{{ panoramicOpg | polyglot }}', fontSize: 'Y', color: 'inkMuted' } }, ImgDate: { text: 'Jan 20, 2026', fontSize: 'Y', color: 'inkMuted' } },
            Img2: { flow: 'y', gap: 'Y', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E', ImgPlaceholder: { width: '100%', height: 'E', background: 'inkSurface', round: 'Y', flow: 'x', align: 'center center', ImgLabel: { text: '{{ periapical14 | polyglot }}', fontSize: 'Y', color: 'inkMuted' } }, ImgDate: { text: 'Mar 8, 2026', fontSize: 'Y', color: 'inkMuted' } },
            Img3: { flow: 'y', gap: 'Y', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E', ImgPlaceholder: { width: '100%', height: 'E', background: 'inkSurface', round: 'Y', flow: 'x', align: 'center center', ImgLabel: { text: '{{ bitewingRl | polyglot }}', fontSize: 'Y', color: 'inkMuted' } }, ImgDate: { text: 'Jan 20, 2026', fontSize: 'Y', color: 'inkMuted' } }
          }
        }
      },

      // ═══════════════════════════════════════════════
      // 7. DOCUMENTS
      // ═══════════════════════════════════════════════
      DocumentsSection: {
        flow: 'y',
        gap: 'A',
        show: (el, s) => s.root.activePatientSection === 'documents',

        XrayGrid: {
          flow: 'x', flexWrap: 'wrap', gap: 'A',
          '@mobileL': { flow: 'y' },
          Xray1: {
            flow: 'y', gap: 'Y', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E', align: 'center center',
            XrayPlaceholder: { width: '100%', height: 'E', background: 'inkSurface', round: 'Y', flow: 'x', align: 'center center', XrayIcon: { extends: 'Icon', icon: 'xray', width: 'B', height: 'B', color: 'inkMuted' } },
            XrayLabel: { text: '{{ periapical14 | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
            XrayDate: { text: 'Mar 10, 2026', fontSize: 'Y', color: 'inkMuted' }
          },
          Xray2: {
            flow: 'y', gap: 'Y', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E', align: 'center center',
            XrayPlaceholder: { width: '100%', height: 'E', background: 'inkSurface', round: 'Y', flow: 'x', align: 'center center', XrayIcon: { extends: 'Icon', icon: 'xray', width: 'B', height: 'B', color: 'inkMuted' } },
            XrayLabel: { text: '{{ panoramicOpg | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
            XrayDate: { text: 'Jan 20, 2026', fontSize: 'Y', color: 'inkMuted' }
          },
          Xray3: {
            flow: 'y', gap: 'Y', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E', align: 'center center',
            XrayPlaceholder: { width: '100%', height: 'E', background: 'inkSurface', round: 'Y', flow: 'x', align: 'center center', XrayIcon: { extends: 'Icon', icon: 'xray', width: 'B', height: 'B', color: 'inkMuted' } },
            XrayLabel: { text: '{{ bitewingRight | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
            XrayDate: { text: 'Jan 20, 2026', fontSize: 'Y', color: 'inkMuted' }
          },
          Xray4: {
            flow: 'y', gap: 'Y', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E', align: 'center center',
            XrayPlaceholder: { width: '100%', height: 'E', background: 'inkSurface', round: 'Y', flow: 'x', align: 'center center', XrayIcon: { extends: 'Icon', icon: 'xray', width: 'B', height: 'B', color: 'inkMuted' } },
            XrayLabel: { text: '{{ bitewingLeft | polyglot }}', fontSize: 'Y', color: 'inkMuted' },
            XrayDate: { text: 'Jan 20, 2026', fontSize: 'Y', color: 'inkMuted' }
          }
        },

        DocsList: {
          flow: 'y', gap: 'Z', marginTop: 'A',
          DocsTitle: { tag: 'h3', text: '{{ patientDocuments | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
          DocRow1: { flow: 'x', gap: 'A', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', align: 'center flex-start', DocInfo: { flow: 'y', gap: 'X', flex: '1', DocName: { text: '{{ consentFormRootCanal | polyglot }}', fontSize: 'Z', fontWeight: '500', color: 'inkText' }, DocDate: { text: 'Mar 3, 2026', fontSize: 'Y', color: 'inkMuted' } }, DocType: { text: 'PDF', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'inkSurface', color: 'inkMuted' } },
          DocRow2: { flow: 'x', gap: 'A', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', align: 'center flex-start', DocInfo: { flow: 'y', gap: 'X', flex: '1', DocName: { text: '{{ treatmentPlanAgreement | polyglot }}', fontSize: 'Z', fontWeight: '500', color: 'inkText' }, DocDate: { text: 'Jan 20, 2026', fontSize: 'Y', color: 'inkMuted' } }, DocType: { text: 'PDF', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'inkSurface', color: 'inkMuted' } },
          DocRow3: { flow: 'x', gap: 'A', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', align: 'center flex-start', DocInfo: { flow: 'y', gap: 'X', flex: '1', DocName: { text: '{{ medicalHistoryQuestionnaire | polyglot }}', fontSize: 'Z', fontWeight: '500', color: 'inkText' }, DocDate: { text: 'Jan 10, 2026', fontSize: 'Y', color: 'inkMuted' } }, DocType: { text: 'PDF', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'inkSurface', color: 'inkMuted' } },
          DocRow4: { flow: 'x', gap: 'A', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', align: 'center flex-start', DocInfo: { flow: 'y', gap: 'X', flex: '1', DocName: { text: '{{ insuranceAuthorizationGpi | polyglot }}', fontSize: 'Z', fontWeight: '500', color: 'inkText' }, DocDate: { text: 'Jan 12, 2026', fontSize: 'Y', color: 'inkMuted' } }, DocType: { text: 'PDF', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'inkSurface', color: 'inkMuted' } }
        },

        UploadBtn: { extends: 'Button', text: '{{ uploadDocument | polyglot }}', marginTop: 'Z', background: 'inkSurface', color: 'inkText', fontWeight: '600', padding: 'Z A', round: 'A', fontSize: 'Z', cursor: 'pointer', border: '1px solid inkBorder' }
      },

      // ═══════════════════════════════════════════════
      // CONSENT
      // ═══════════════════════════════════════════════
      ConsentSection: {
        flow: 'y', gap: 'A',
        show: (el, s) => s.root.activePatientSection === 'consent',

        ConsentHeader: {
          flow: 'x', gap: 'A', align: 'center space-between', flexWrap: 'wrap',
          ConsentTitle: { tag: 'h3', text: 'Consent Forms', fontSize: 'A', fontWeight: '700', color: 'inkText' },
          NewConsentBtn: {
            flow: 'x', gap: 'Y', align: 'center center',
            padding: 'Y A', round: 'A', background: 'teal', color: 'white',
            fontSize: 'Z', fontWeight: '600', cursor: 'pointer', border: 'none',
            BtnIcon: { tag: 'span', text: '+' },
            BtnLabel: { tag: 'span', text: 'Request New Consent' }
          }
        },

        ConsentStats: {
          flow: 'x', gap: 'A', flexWrap: 'wrap',
          StatSigned: { flow: 'y', gap: 'X', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid green.20', flex: '1', minWidth: 'E', SVal: { text: '3', fontSize: 'C', fontWeight: '700', color: 'green' }, SLabel: { text: 'Signed', fontSize: 'Y', color: 'inkMuted' } },
          StatPending: { flow: 'y', gap: 'X', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid gold.20', flex: '1', minWidth: 'E', SVal2: { text: '1', fontSize: 'C', fontWeight: '700', color: 'gold' }, SLabel2: { text: 'Pending Signature', fontSize: 'Y', color: 'inkMuted' } },
          StatExpired: { flow: 'y', gap: 'X', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'E', SVal3: { text: '0', fontSize: 'C', fontWeight: '700', color: 'inkMuted' }, SLabel3: { text: 'Expired', fontSize: 'Y', color: 'inkMuted' } }
        },

        ConsentList: {
          flow: 'y', gap: 'Z',
          ConsentListTitle: { tag: 'h4', text: 'All Consent Forms', fontSize: 'Z', fontWeight: '700', color: 'inkText', marginBottom: 'X' },

          CForm1: {
            flow: 'x', gap: 'A', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid green.20', align: 'center flex-start',
            CFormIcon1: { tag: 'span', text: '✅', fontSize: 'A', flexShrink: '0' },
            CFormInfo1: { flow: 'y', gap: 'X', flex: '1',
              CFormName1: { text: 'Root Canal Treatment — Tooth #14', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
              CFormMeta1: { flow: 'x', gap: 'A', CFormDate1: { text: 'Signed Mar 3, 2026', fontSize: 'Y', color: 'green' }, CFormDoc1: { text: 'Dr. Kvaratskhelia', fontSize: 'Y', color: 'inkMuted' } }
            },
            CFormBadge1: { text: 'Signed', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'green.15', color: 'green' },
            CFormAction1: { tag: 'span', text: 'View PDF', fontSize: 'Y', color: 'teal', cursor: 'pointer', fontWeight: '600', marginLeft: 'Y' }
          },

          CForm2: {
            flow: 'x', gap: 'A', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid green.20', align: 'center flex-start',
            CFormIcon2: { tag: 'span', text: '✅', fontSize: 'A', flexShrink: '0' },
            CFormInfo2: { flow: 'y', gap: 'X', flex: '1',
              CFormName2: { text: 'Treatment Plan Agreement', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
              CFormMeta2: { flow: 'x', gap: 'A', CFormDate2: { text: 'Signed Jan 20, 2026', fontSize: 'Y', color: 'green' }, CFormDoc2: { text: 'Dr. Kvaratskhelia', fontSize: 'Y', color: 'inkMuted' } }
            },
            CFormBadge2: { text: 'Signed', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'green.15', color: 'green' },
            CFormAction2: { tag: 'span', text: 'View PDF', fontSize: 'Y', color: 'teal', cursor: 'pointer', fontWeight: '600', marginLeft: 'Y' }
          },

          CForm3: {
            flow: 'x', gap: 'A', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid green.20', align: 'center flex-start',
            CFormIcon3: { tag: 'span', text: '✅', fontSize: 'A', flexShrink: '0' },
            CFormInfo3: { flow: 'y', gap: 'X', flex: '1',
              CFormName3: { text: 'Medical History & HIPAA Authorization', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
              CFormMeta3: { flow: 'x', gap: 'A', CFormDate3: { text: 'Signed Jan 10, 2026', fontSize: 'Y', color: 'green' }, CFormDoc3: { text: 'Dr. Kvaratskhelia', fontSize: 'Y', color: 'inkMuted' } }
            },
            CFormBadge3: { text: 'Signed', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'green.15', color: 'green' },
            CFormAction3: { tag: 'span', text: 'View PDF', fontSize: 'Y', color: 'teal', cursor: 'pointer', fontWeight: '600', marginLeft: 'Y' }
          },

          CForm4: {
            flow: 'x', gap: 'A', padding: 'A', round: 'A', background: 'inkMid', border: '1px solid gold.30', align: 'center flex-start',
            CFormIcon4: { tag: 'span', text: '⏳', fontSize: 'A', flexShrink: '0' },
            CFormInfo4: { flow: 'y', gap: 'X', flex: '1',
              CFormName4: { text: 'Implant Surgery — Tooth #36 Consent', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
              CFormMeta4: { flow: 'x', gap: 'A', CFormDate4: { text: 'Sent Mar 16, 2026 · Awaiting signature', fontSize: 'Y', color: 'gold' }, CFormDoc4: { text: 'Dr. Lomidze', fontSize: 'Y', color: 'inkMuted' } }
            },
            CFormBadge4: { text: 'Pending', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B', background: 'gold.15', color: 'gold' },
            CFormResend4: { tag: 'span', text: 'Resend', fontSize: 'Y', color: 'teal', cursor: 'pointer', fontWeight: '600', marginLeft: 'Y' }
          }
        }
      }
    },
    MobileTabBar: {}
  }
}
